"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9858],{

/***/ 38144:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Card_Card; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(94589);
// EXTERNAL MODULE: ./node_modules/styled-system/dist/index.esm.js + 13 modules
var index_esm = __webpack_require__(57247);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Box.tsx
var Box = __webpack_require__(44850);
;// CONCATENATED MODULE: ./packages/uikit/src/components/Card/StyledCard.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  0% {\n    background-position: 50% 0%;\n  }\n  50% {\n    background-position: 50% 100%;\n  }\n  100% {\n    background-position: 50% 0%;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      animation: ",
        " 3s ease infinite;\n      background-size: 400% 400%;\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  border-radius: ",
        ";\n  color: ",
        ";\n  overflow: hidden;\n  position: relative;\n\n  ",
        "\n\n  /* padding: 1px 1px 3px 1px; */\n\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 100%;\n  overflow: ",
        ";\n  background: ",
        ";\n  border-radius: ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var PromotedGradient = (0,styled_components_browser_esm/* keyframes */.F4)(_templateObject());
/**
 * Priority: Warning --> Success --> Active
 */ var getBorderColor = function getBorderColor(param) {
    var isActive = param.isActive, isSuccess = param.isSuccess, isWarning = param.isWarning, borderBackground = param.borderBackground, theme = param.theme;
    if (borderBackground) {
        return borderBackground;
    }
    if (isWarning) {
        return theme.colors.warning;
    }
    if (isSuccess) {
        return theme.colors.success;
    }
    if (isActive) {
        return "linear-gradient(180deg, ".concat(theme.colors.primaryBright, ", ").concat(theme.colors.secondary, ")");
    }
    return "rgba(255, 255, 255, 0.2)";
};
var StyledCard = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-da971217-0"
}).withConfig({
    componentId: "sc-73b1267d-0"
})(_templateObject2(), getBorderColor, function(param) {
    var theme = param.theme;
    return theme.radii.card;
}, function(param) {
    var theme = param.theme, isDisabled = param.isDisabled;
    return theme.colors[isDisabled ? "textDisabled" : "text"];
}, function(param) {
    var isActive = param.isActive;
    return isActive && (0,styled_components_browser_esm/* css */.iv)(_templateObject1(), PromotedGradient);
}, index_esm/* space */.Dh);
var StyledCardInner = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
    componentId: "sc-da971217-1"
}).withConfig({
    componentId: "sc-73b1267d-1"
})(_templateObject3(), function(param) {
    var hasCustomBorder = param.hasCustomBorder;
    return hasCustomBorder ? "initial" : "inherit";
}, function(param) {
    var background = param.background;
    return background !== null && background !== void 0 ? background : "rgba(255, 255, 255, 0.2)";
}, function(param) {
    var theme = param.theme;
    return theme.radii.card;
});
StyledCard.defaultProps = {
    isActive: false,
    isSuccess: false,
    isWarning: false,
    isDisabled: false
};

;// CONCATENATED MODULE: ./packages/uikit/src/components/Card/Card.tsx






var Card = function Card(_param) {
    var ribbon = _param.ribbon, children = _param.children, background = _param.background, props = (0,_object_without_properties/* default */.Z)(_param, [
        "ribbon",
        "children",
        "background"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCard, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledCardInner, {
            background: background,
            hasCustomBorder: !!props.borderBackground,
            children: [
                ribbon,
                children
            ]
        })
    }));
};
/* harmony default export */ var Card_Card = (Card);


/***/ }),

/***/ 19731:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Checkbox_Checkbox; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(94589);
;// CONCATENATED MODULE: ./packages/uikit/src/components/Checkbox/types.ts
var scales = {
    SM: "sm",
    MD: "md"
};

;// CONCATENATED MODULE: ./packages/uikit/src/components/Checkbox/Checkbox.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  appearance: none;\n  overflow: hidden;\n  cursor: pointer;\n  position: relative;\n  display: inline-block;\n  height: ",
        ";\n  width: ",
        ";\n  vertical-align: middle;\n  transition: background-color 0.2s ease-in-out;\n  border: 0;\n  border-radius: 8px;\n  background-color: ",
        ";\n  box-shadow: ",
        ';\n\n  &:after {\n    content: "";\n    position: absolute;\n    border-bottom: 2px solid;\n    border-left: 2px solid;\n    border-color: transparent;\n    top: 30%;\n    left: 0;\n    right: 0;\n    width: 50%;\n    height: 25%;\n    margin: auto;\n    transform: rotate(-50deg);\n    transition: border-color 0.2s ease-in-out;\n  }\n\n  &:hover:not(:disabled):not(:checked) {\n    box-shadow: ',
        ";\n  }\n\n  &:focus {\n    outline: none;\n    box-shadow: ",
        ";\n  }\n\n  &:checked {\n    background-color: ",
        ";\n    &:after {\n      border-color: white;\n    }\n  }\n\n  &:disabled {\n    cursor: default;\n    opacity: 0.6;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var getScale = function getScale(param) {
    var scale = param.scale;
    switch(scale){
        case scales.SM:
            return "24px";
        case scales.MD:
        default:
            return "32px";
    }
};
var Checkbox = styled_components_browser_esm/* default.input.attrs */.ZP.input.attrs({
    type: "checkbox"
}).withConfig({
    componentId: "sc-11bd21f1-0"
}).withConfig({
    componentId: "sc-d4d20c70-0"
})(_templateObject(), getScale, getScale, function(param) {
    var theme = param.theme;
    return theme.colors.input;
}, function(param) {
    var theme = param.theme;
    return theme.shadows.inset;
}, function(param) {
    var theme = param.theme;
    return theme.shadows.focus;
}, function(param) {
    var theme = param.theme;
    return theme.shadows.focus;
}, function(param) {
    var theme = param.theme;
    return theme.colors.success;
});
Checkbox.defaultProps = {
    scale: scales.MD
};
/* harmony default export */ var Checkbox_Checkbox = (Checkbox);


/***/ }),

/***/ 5324:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94589);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39112);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  // background-color: ",
        ";\n  border-radius: 16px;\n  // box-shadow: ",
        ";\n  color: ",
        ";\n  display: block;\n  font-size: 16px;\n  height: ",
        ";\n  outline: 0;\n  padding: 0 16px;\n  width: 100%;\n  // border: 1px solid ",
        ";\n  border: none;\n  font-weight: 600;\n\n  &::placeholder {\n    /* color: ",
        "; */\n    color: #999;\n  }\n\n  &:disabled {\n    background-color: ",
        ";\n    box-shadow: none;\n    color: ",
        ";\n    cursor: not-allowed;\n  }\n\n  &:focus:not(:disabled) {\n    box-shadow: ",
        ";\n    box-shadow: none;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


/**
 * Priority: Warning --> Success
 */ var getBoxShadow = function getBoxShadow(param) {
    var _isSuccess = param.isSuccess, isSuccess = _isSuccess === void 0 ? false : _isSuccess, _isWarning = param.isWarning, isWarning = _isWarning === void 0 ? false : _isWarning, theme = param.theme;
    if (isWarning) {
        return theme.shadows.warning;
    }
    if (isSuccess) {
        return theme.shadows.success;
    }
    return theme.shadows.inset;
};
var getHeight = function getHeight(param) {
    var _scale = param.scale, scale = _scale === void 0 ? _types__WEBPACK_IMPORTED_MODULE_1__/* .scales.MD */ .Q.MD : _scale;
    switch(scale){
        case _types__WEBPACK_IMPORTED_MODULE_1__/* .scales.SM */ .Q.SM:
            return "32px";
        case _types__WEBPACK_IMPORTED_MODULE_1__/* .scales.LG */ .Q.LG:
            return "48px";
        case _types__WEBPACK_IMPORTED_MODULE_1__/* .scales.MD */ .Q.MD:
        default:
            return "40px";
    }
};
var Input = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].input.withConfig */ .ZP.input.withConfig({
    componentId: "sc-996b64d7-0"
}).withConfig({
    componentId: "sc-de4b360c-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.input;
}, getBoxShadow, function(param) {
    var theme = param.theme;
    return theme.colors.text;
}, getHeight, function(param) {
    var theme = param.theme;
    return theme.colors.inputSecondary;
}, function(param) {
    var theme = param.theme;
    return theme.colors.textSubtle;
}, function(param) {
    var theme = param.theme;
    return theme.colors.backgroundDisabled;
}, function(param) {
    var theme = param.theme;
    return theme.colors.textDisabled;
}, function(param) {
    var theme = param.theme, isWarning = param.isWarning, isSuccess = param.isSuccess;
    if (isWarning) {
        return theme.shadows.warning;
    }
    if (isSuccess) {
        return theme.shadows.success;
    }
    return theme.shadows.focus;
});
Input.defaultProps = {
    scale: _types__WEBPACK_IMPORTED_MODULE_1__/* .scales.MD */ .Q.MD,
    isSuccess: false,
    isWarning: false
};
/* harmony default export */ __webpack_exports__["Z"] = (Input);


/***/ }),

/***/ 39112:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ scales; }
/* harmony export */ });
var scales = {
    SM: "sm",
    MD: "md",
    LG: "lg"
};


/***/ }),

/***/ 45341:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94589);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: inline-flex;\n  position: relative;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: ",
        ";\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 10px;\n  height: 10px;\n  pointer-events: none;\n  border: 2px solid ",
        ";\n  border-radius: 50%;\n  background-color: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var NotificationDotRoot = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-a93f15de-0"
}).withConfig({
    componentId: "sc-c1ffb375-0"
})(_templateObject());
var Dot = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-a93f15de-1"
}).withConfig({
    componentId: "sc-c1ffb375-1"
})(_templateObject1(), function(param) {
    var show = param.show;
    return show ? "inline-flex" : "none";
}, function(param) {
    var theme = param.theme;
    return theme.colors.invertedContrast;
}, function(param) {
    var theme = param.theme, color = param.color;
    return theme.colors[color];
});
var NotificationDot = function NotificationDot(_param) /*#__PURE__*/ {
    var _show = _param.show, show = _show === void 0 ? false : _show, _color = _param.color, color = _color === void 0 ? "failure" : _color, children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "show",
        "color",
        "children"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(NotificationDotRoot, {
        children: [
            react__WEBPACK_IMPORTED_MODULE_2__.Children.map(children, function(child) {
                return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.cloneElement)(child, props);
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Dot, {
                show: show,
                color: color
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (NotificationDot);


/***/ }),

/***/ 20508:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Toggle_Toggle; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Flex.tsx
var Flex = __webpack_require__(4318);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(94589);
;// CONCATENATED MODULE: ./packages/uikit/src/components/Toggle/types.ts
var scales = {
    SM: "sm",
    MD: "md",
    LG: "lg"
};
var scaleKeys = {
    handleHeight: "handleHeight",
    handleWidth: "handleWidth",
    handleLeft: "handleLeft",
    handleTop: "handleTop",
    checkedLeft: "checkedLeft",
    toggleHeight: "toggleHeight",
    toggleWidth: "toggleWidth"
};

;// CONCATENATED MODULE: ./packages/uikit/src/components/Toggle/StyledToggle.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  // background-color: ",
        ";\n  background-color: ",
        ";\n  border-radius: 50%;\n  cursor: pointer;\n  height: ",
        ";\n  left: ",
        ";\n  position: absolute;\n  top: ",
        ";\n  transition: left 200ms ease-in;\n  width: ",
        ";\n  z-index: 1;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  cursor: pointer;\n  opacity: 0;\n  height: 100%;\n  position: absolute;\n  width: 100%;\n  z-index: 3;\n  &:checked + ",
        " {\n    left: ",
        ";\n  }\n\n  // &:focus + ",
        " {\n  //   box-shadow: ",
        ";\n  // }\n\n  // &:hover + ",
        ":not(:disabled):not(:checked) {\n  //   box-shadow: ",
        ";\n  // }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  background-color: ",
        ";\n  border-radius: 24px;\n  // box-shadow: ",
        ";\n  border: 1px solid #000;\n  cursor: pointer;\n  display: inline-flex;\n  height: ",
        ";\n  position: relative;\n  transition: background-color 200ms;\n  width: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var scaleKeyValues = {
    sm: {
        handleHeight: "16px",
        handleWidth: "16px",
        handleLeft: "2px",
        handleTop: "1px",
        checkedLeft: "calc(100% - 18px)",
        toggleHeight: "20px",
        toggleWidth: "36px"
    },
    md: {
        handleHeight: "26px",
        handleWidth: "26px",
        handleLeft: "3px",
        handleTop: "3px",
        checkedLeft: "calc(100% - 30px)",
        toggleHeight: "32px",
        toggleWidth: "56px"
    },
    lg: {
        handleHeight: "32px",
        handleWidth: "32px",
        handleLeft: "4px",
        handleTop: "4px",
        checkedLeft: "calc(100% - 36px)",
        toggleHeight: "40px",
        toggleWidth: "72px"
    }
};
var getScale = function getScale(property) {
    return function(param) {
        var _scale = param.scale, scale = _scale === void 0 ? scales.LG : _scale;
        return scaleKeyValues[scale][property];
    };
};
var Handle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6f7dd37e-0"
}).withConfig({
    componentId: "sc-ab43b288-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.toggle.handleBackground;
}, function(param) {
    var theme = param.theme, $checked = param.$checked;
    return $checked ? theme.toggle.handleBackground : "#7F7F7F";
}, getScale("handleHeight"), getScale("handleLeft"), getScale("handleTop"), getScale("handleWidth"));
var Input = styled_components_browser_esm/* default.input.withConfig */.ZP.input.withConfig({
    componentId: "sc-6f7dd37e-1"
}).withConfig({
    componentId: "sc-ab43b288-1"
})(_templateObject1(), Handle, getScale("checkedLeft"), Handle, function(param) {
    var theme = param.theme;
    return theme.shadows.focus;
}, Handle, function(param) {
    var theme = param.theme;
    return theme.shadows.focus;
});
var StyledToggle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6f7dd37e-2"
}).withConfig({
    componentId: "sc-ab43b288-2"
})(_templateObject2(), function(param) {
    var theme = param.theme, $checked = param.$checked, $checkedColor = param.$checkedColor, $defaultColor = param.$defaultColor;
    return theme.colors[$checked ? $checkedColor : $defaultColor];
}, function(param) {
    var theme = param.theme;
    return theme.shadows.inset;
}, getScale("toggleHeight"), getScale("toggleWidth"));
/* harmony default export */ var Toggle_StyledToggle = (StyledToggle);

;// CONCATENATED MODULE: ./packages/uikit/src/components/Toggle/Toggle.tsx








var Toggle = function Toggle(_param) {
    var checked = _param.checked, _defaultColor = _param.defaultColor, defaultColor = _defaultColor === void 0 ? "input" : _defaultColor, _checkedColor = _param.checkedColor, checkedColor = _checkedColor === void 0 ? "primary" : _checkedColor, _scale = _param.scale, scale = _scale === void 0 ? scales.LG : _scale, startIcon = _param.startIcon, endIcon = _param.endIcon, props = (0,_object_without_properties/* default */.Z)(_param, [
        "checked",
        "defaultColor",
        "checkedColor",
        "scale",
        "startIcon",
        "endIcon"
    ]);
    var isChecked = !!checked;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Toggle_StyledToggle, {
        $checked: isChecked,
        $checkedColor: checkedColor,
        $defaultColor: defaultColor,
        scale: scale,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                checked: checked,
                scale: scale
            }, props), {
                type: "checkbox"
            })),
            startIcon && endIcon ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Handle, {
                        scale: scale,
                        $checked: isChecked,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                            height: "100%",
                            alignItems: "center",
                            justifyContent: "center",
                            children: checked ? endIcon(checked) : startIcon(!checked)
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        width: "100%",
                        height: "100%",
                        justifyContent: "space-around",
                        alignItems: "center",
                        children: [
                            startIcon(),
                            endIcon()
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Handle, {
                scale: scale,
                $checked: isChecked
            })
        ]
    });
};
/* harmony default export */ var Toggle_Toggle = (Toggle);


/***/ }),

/***/ 72609:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "j": function() { return /* reexport */ AppBody; },
  "t": function() { return /* reexport */ App_AppHeader; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(94589);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Flex.tsx
var Flex = __webpack_require__(4318);
// EXTERNAL MODULE: ./packages/uikit/src/components/Button/IconButton.tsx
var IconButton = __webpack_require__(5527);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/ArrowBack.tsx
var ArrowBack = __webpack_require__(69508);
// EXTERNAL MODULE: ./packages/uikit/src/components/Heading/Heading.tsx + 1 modules
var Heading = __webpack_require__(59750);
// EXTERNAL MODULE: ./packages/uikit/src/components/NotificationDot/NotificationDot.tsx
var NotificationDot = __webpack_require__(45341);
// EXTERNAL MODULE: ./packages/uikit/src/components/Button/Button.tsx + 2 modules
var Button = __webpack_require__(96293);
// EXTERNAL MODULE: ./packages/uikit/src/components/Text/Text.tsx
var Text = __webpack_require__(97114);
// EXTERNAL MODULE: ./src/state/user/hooks/index.tsx
var hooks = __webpack_require__(68605);
// EXTERNAL MODULE: ./src/components/Menu/GlobalSettings/index.tsx + 4 modules
var GlobalSettings = __webpack_require__(8742);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./packages/localization/src/index.tsx + 4 modules
var src = __webpack_require__(65208);
// EXTERNAL MODULE: ./src/components/QuestionHelper/index.tsx
var QuestionHelper = __webpack_require__(45061);
// EXTERNAL MODULE: ./src/components/Menu/GlobalSettings/types.ts
var types = __webpack_require__(47431);
;// CONCATENATED MODULE: ./src/components/App/AppHeader.tsx


function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  justify-content: space-between;\n  padding: 24px;\n  width: 100%;\n  /* border-bottom: 1px solid ",
        "; */\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}







// import Transactions from './Transactions'


var AppHeaderContainer = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-8ef6e4b6-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.cardBorder;
});
var AppHeader = function(param) {
    var title = param.title, subtitle = param.subtitle, helper = param.helper, backTo = param.backTo, _noConfig = param.noConfig, noConfig = _noConfig === void 0 ? false : _noConfig, _type = param.type, type = _type === void 0 ? false : _type;
    var ref = (0,_sliced_to_array/* default */.Z)((0,hooks/* useExpertModeManager */.DG)(), 1), expertMode = ref[0];
    var t = (0,src/* useTranslation */.$G)().t;
    // get custom setting values for user
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,hooks/* useUserSlippageTolerance */.$2)(), 1), allowedSlippage = ref1[0];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AppHeaderContainer, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
            alignItems: "center",
            width: "100%",
            style: {
                gap: "16px"
            },
            children: [
                backTo && (typeof backTo === "string" ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    passHref: true,
                    href: backTo,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                        as: "a",
                        scale: "sm",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowBack/* default */.Z, {
                            width: "32px"
                        })
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                    scale: "sm",
                    variant: "text",
                    onClick: backTo,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowBack/* default */.Z, {
                        width: "32px"
                    })
                })),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    flexDirection: "column",
                    width: "100%",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                            alignItems: "center",
                            justifyContent: "space-between",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                    as: "h2",
                                    children: title
                                }),
                                !noConfig && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                    alignItems: "center",
                                    children: [
                                        !type && /*#__PURE__*/ (0,jsx_runtime.jsx)(NotificationDot/* default */.Z, {
                                            show: expertMode,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalSettings/* default */.Z, {
                                                mode: types/* SettingsMode.SWAP_LIQUIDITY */.a.SWAP_LIQUIDITY
                                            })
                                        }),
                                        type && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "/find",
                                            passHref: true,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                id: "import-pool-link",
                                                scale: "sm",
                                                as: "a",
                                                style: {
                                                    background: "transparent"
                                                },
                                                children: t("noah110")
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                            alignItems: "center",
                            children: [
                                helper && /*#__PURE__*/ (0,jsx_runtime.jsx)(QuestionHelper/* default */.Z, {
                                    text: helper,
                                    mr: "4px",
                                    placement: "top-start"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    color: "textSubtle",
                                    fontSize: "14px",
                                    children: subtitle
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var App_AppHeader = (AppHeader);

// EXTERNAL MODULE: ./packages/uikit/src/components/Card/Card.tsx + 1 modules
var Card = __webpack_require__(38144);
;// CONCATENATED MODULE: ./src/components/App/AppBody.tsx

function AppBody_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 24px;\n  max-width: ",
        ";\n  width: 100%;\n  z-index: 1;\n"
    ]);
    AppBody_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var BodyWrapper = (0,styled_components_browser_esm/* default */.ZP)(Card/* default */.Z).withConfig({
    componentId: "sc-b1a3e9f5-0"
})(AppBody_templateObject(), function(param) {
    var noMaxWidth = param.noMaxWidth;
    return noMaxWidth ? "none" : "440px";
});
/**
 * The styled container element that wraps the content of most pages and the tabs.
 */ function AppBody(param) {
    var children = param.children, noMaxWidth = param.noMaxWidth;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyWrapper, {
        noMaxWidth: noMaxWidth,
        children: children
    });
}

;// CONCATENATED MODULE: ./src/components/App/index.tsx




/***/ }),

/***/ 39475:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BA": function() { return /* binding */ AutoRow; },
/* harmony export */   "DA": function() { return /* binding */ RowFixed; },
/* harmony export */   "m0": function() { return /* binding */ RowBetween; }
/* harmony export */ });
/* unused harmony export RowFlat */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94589);
/* harmony import */ var _noahswap_uikit__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44850);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: ",
        ";\n  display: flex;\n  align-items: ",
        ";\n  justify-content: ",
        ";\n  padding: ",
        ";\n  border: ",
        ";\n  border-radius: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  justify-content: space-between;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: flex-end;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  flex-wrap: wrap;\n  margin: ",
        ";\n  justify-content: ",
        ";\n\n  & > * {\n    margin: ",
        " !important;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: fit-content;\n  margin: ",
        ";\n\n  & > * {\n    margin: ",
        " !important;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}


var Row = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_noahswap_uikit__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-bc277a35-0"
})(_templateObject(), function(param) {
    var width = param.width;
    return width !== null && width !== void 0 ? width : "100%";
}, function(param) {
    var align = param.align;
    return align !== null && align !== void 0 ? align : "center";
}, function(param) {
    var justify = param.justify;
    return justify !== null && justify !== void 0 ? justify : "flex-start";
}, function(param) {
    var padding = param.padding;
    return padding !== null && padding !== void 0 ? padding : "0";
}, function(param) {
    var border = param.border;
    return border;
}, function(param) {
    var borderRadius = param.borderRadius;
    return borderRadius;
});
var RowBetween = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(Row).withConfig({
    componentId: "sc-bc277a35-1"
})(_templateObject1());
var RowFlat = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-bc277a35-2"
})(_templateObject2());
var AutoRow = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(Row).withConfig({
    componentId: "sc-bc277a35-3"
})(_templateObject3(), function(param) {
    var gap = param.gap;
    return gap && "-".concat(gap);
}, function(param) {
    var justify = param.justify;
    return justify;
}, function(param) {
    var gap = param.gap;
    return gap;
});
var RowFixed = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(Row).withConfig({
    componentId: "sc-bc277a35-4"
})(_templateObject4(), function(param) {
    var gap = param.gap;
    return gap && "-".concat(gap);
}, function(param) {
    var gap = param.gap;
    return gap;
});
/* harmony default export */ __webpack_exports__["ZP"] = (Row);


/***/ }),

/***/ 34966:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CurrencyLogo; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(94589);
/* harmony import */ var hooks_useActiveWeb3React__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64011);
/* harmony import */ var _Logo__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79350);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: ",
        ";\n  height: ",
        ";\n  border-radius: 50%;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var StyledLogo = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_Logo__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-3deedc91-0"
})(_templateObject(), function(param) {
    var size = param.size;
    return size;
}, function(param) {
    var size = param.size;
    return size;
});
function CurrencyLogo(param) {
    var currency = param.currency, _size = param.size, size = _size === void 0 ? "24px" : _size, style = param.style;
    var chainId = (0,hooks_useActiveWeb3React__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)().chainId;
    var srcs = [];
    if ((currency === null || currency === void 0 ? void 0 : currency.symbol) === "EOS" || (currency === null || currency === void 0 ? void 0 : currency.symbol) === "WEOS") {
        // srcs = [
        //   `https://s3.ap-southeast-1.amazonaws.com/noahark.pro/image/17777-0xc00592aa41d32d137dc480d9f6d0df19b860104f-eos.png`,
        // ]
        srcs = [
            "https://s3.ap-northeast-1.amazonaws.com/1noahark.io/image/17777-0xc00592aa41d32d137dc480d9f6d0df19b860104f-eos.png", 
        ];
    // currency?.symbol === 'BTC' ||
    } else if ((currency === null || currency === void 0 ? void 0 : currency.symbol) === "BTC") {
        srcs = [
            "/images/small-img/btc.svg"
        ];
    } else if ((currency === null || currency === void 0 ? void 0 : currency.symbol) === "XBTC") {
        srcs = [
            "https://s3.ap-northeast-1.amazonaws.com/1noahark.io/image/7200-0x4aa4365da82acd46e378a6f3c92a863f3e763d34-xbtc.png", 
        ];
    } else if ((currency === null || currency === void 0 ? void 0 : currency.address) && (currency === null || currency === void 0 ? void 0 : currency.symbol)) {
        // srcs = [
        //   `https://s3.ap-southeast-1.amazonaws.com/noahark.pro/image/${chainId}-${currency?.address.toLowerCase()}-${currency?.symbol.toLowerCase()}.png`,
        // ]
        srcs = [
            "https://s3.ap-northeast-1.amazonaws.com/1noahark.io/image/".concat(chainId, "-").concat(currency === null || currency === void 0 ? void 0 : currency.address.toLowerCase(), "-").concat(currency === null || currency === void 0 ? void 0 : currency.symbol.toLowerCase(), ".png"), 
        ];
    }
    var ref;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledLogo, {
        size: size,
        srcs: srcs,
        alt: "".concat((ref = currency === null || currency === void 0 ? void 0 : currency.symbol) !== null && ref !== void 0 ? ref : "token", " logo"),
        style: style
    });
}


/***/ }),

/***/ 79350:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ BAD_SRCS; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);





var BAD_SRCS = {};
/**
 * Renders an image by sequentially trying a list of URIs, and then eventually a fallback triangle alert
 */ var Logo = function(_param) {
    var srcs = _param.srcs, alt = _param.alt, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "srcs",
        "alt"
    ]);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0), refresh = ref[1];
    var src = srcs.find(function(s) {
        return !BAD_SRCS[s];
    });
    if (src) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest), {
            alt: alt,
            src: src,
            onError: function() {
                if (src) BAD_SRCS[src] = true;
                refresh(function(i) {
                    return i + 1;
                });
            }
        }));
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest), {
        src: "/images/small-img/default-icon.png",
        alt: ""
    }));
// return <HelpIcon {...rest} />
};
/* harmony default export */ __webpack_exports__["Z"] = (Logo);


/***/ }),

/***/ 98956:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Xw": function() { return /* reexport */ CurrencyLogo/* default */.Z; },
  "ge": function() { return /* reexport */ DoubleCurrencyLogo; },
  "_r": function() { return /* reexport */ ListLogo; }
});

// EXTERNAL MODULE: ./src/components/Logo/CurrencyLogo.tsx
var CurrencyLogo = __webpack_require__(34966);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(94589);
;// CONCATENATED MODULE: ./src/components/Logo/DoubleLogo.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  margin-right: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d4ab4b9b-0"
})(_templateObject(), function(param) {
    var margin = param.margin;
    return margin && "4px";
});
function DoubleCurrencyLogo(param) {
    var currency0 = param.currency0, currency1 = param.currency1, _size = param.size, size = _size === void 0 ? 20 : _size, _margin = param.margin, margin = _margin === void 0 ? false : _margin;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        margin: margin,
        children: [
            currency0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrencyLogo/* default */.Z, {
                currency: currency0,
                size: "".concat(size.toString(), "px"),
                style: {
                    marginRight: "-5px"
                }
            }),
            currency1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrencyLogo/* default */.Z, {
                currency: currency1,
                size: "".concat(size.toString(), "px")
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/utils/uriToHttp.ts
var uriToHttp = __webpack_require__(90570);
;// CONCATENATED MODULE: ./src/hooks/useHttpLocations.ts


function useHttpLocations(uri) {
    return (0,react.useMemo)(function() {
        return uri ? (0,uriToHttp/* default */.Z)(uri) : [];
    }, [
        uri
    ]);
}

// EXTERNAL MODULE: ./src/components/Logo/Logo.tsx
var Logo = __webpack_require__(79350);
;// CONCATENATED MODULE: ./src/components/Logo/ListLogo.tsx

function ListLogo_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: ",
        ";\n  height: ",
        ";\n"
    ]);
    ListLogo_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var StyledListLogo = (0,styled_components_browser_esm/* default */.ZP)(Logo/* default */.Z).withConfig({
    componentId: "sc-60793395-0"
})(ListLogo_templateObject(), function(param) {
    var size = param.size;
    return size;
}, function(param) {
    var size = param.size;
    return size;
});
function ListLogo(param) {
    var logoURI = param.logoURI, style = param.style, _size = param.size, size = _size === void 0 ? "24px" : _size, alt = param.alt;
    var srcs = useHttpLocations(logoURI);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledListLogo, {
        alt: alt,
        size: size,
        srcs: srcs,
        style: style
    });
}

;// CONCATENATED MODULE: ./src/components/Logo/index.ts





/***/ }),

/***/ 8742:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Menu_GlobalSettings; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./packages/uikit/src/widgets/Modal/useModal.ts
var useModal = __webpack_require__(65528);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Flex.tsx
var Flex = __webpack_require__(4318);
// EXTERNAL MODULE: ./packages/uikit/src/components/Button/IconButton.tsx
var IconButton = __webpack_require__(5527);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(94589);
// EXTERNAL MODULE: ./packages/uikit/src/widgets/Modal/Modal.tsx
var Modal = __webpack_require__(90452);
// EXTERNAL MODULE: ./packages/uikit/src/components/Text/Text.tsx
var Text = __webpack_require__(97114);
// EXTERNAL MODULE: ./packages/uikit/src/components/Toggle/Toggle.tsx + 2 modules
var Toggle = __webpack_require__(20508);
// EXTERNAL MODULE: ./src/state/user/hooks/index.tsx
var hooks = __webpack_require__(68605);
// EXTERNAL MODULE: ./packages/localization/src/index.tsx + 4 modules
var src = __webpack_require__(65208);
// EXTERNAL MODULE: ./src/hooks/useTheme.ts + 1 modules
var useTheme = __webpack_require__(25628);
// EXTERNAL MODULE: ./src/components/QuestionHelper/index.tsx
var QuestionHelper = __webpack_require__(45061);
// EXTERNAL MODULE: ./src/utils/index.ts
var utils = __webpack_require__(93293);
// EXTERNAL MODULE: ./packages/uikit/src/components/Button/Button.tsx + 2 modules
var Button = __webpack_require__(96293);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Box.tsx
var Box = __webpack_require__(44850);
// EXTERNAL MODULE: ./packages/uikit/src/components/Input/Input.tsx
var Input = __webpack_require__(5324);
;// CONCATENATED MODULE: ./src/components/Menu/GlobalSettings/TransactionSettings.tsx








var SlippageError;
(function(SlippageError) {
    SlippageError["InvalidInput"] = "InvalidInput";
    SlippageError["RiskyLow"] = "RiskyLow";
    SlippageError["RiskyHigh"] = "RiskyHigh";
})(SlippageError || (SlippageError = {}));
var DeadlineError;
(function(DeadlineError) {
    DeadlineError["InvalidInput"] = "InvalidInput";
})(DeadlineError || (DeadlineError = {}));
var inputRegex = RegExp("^\\d*(?:\\\\[.])?\\d*$") // match escaped "." characters via in a non-capturing group
;
var THREE_DAYS_IN_SECONDS = 60 * 60 * 24 * 3;
var SlippageTabs = function() {
    var ref = (0,_sliced_to_array/* default */.Z)((0,hooks/* useUserSlippageTolerance */.$2)(), 2), userSlippageTolerance = ref[0], setUserSlippageTolerance = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,hooks/* useUserTransactionTTL */.A6)(), 2), ttl = ref1[0], setTtl = ref1[1];
    var ref2 = (0,react.useState)((userSlippageTolerance / 100).toFixed(2) || ""), slippageInput = ref2[0], setSlippageInput = ref2[1];
    var ref3 = (0,react.useState)(""), deadlineInput = ref3[0], setDeadlineInput = ref3[1];
    var t = (0,src/* useTranslation */.$G)().t;
    var slippageInputIsValid = slippageInput === "" || (userSlippageTolerance / 100).toFixed(2) === Number.parseFloat(slippageInput).toFixed(2);
    var deadlineInputIsValid = deadlineInput === "" || (ttl / 60).toString() === deadlineInput;
    var slippageError;
    if (slippageInput !== "" && !slippageInputIsValid) {
        slippageError = SlippageError.InvalidInput;
    } else if (slippageInputIsValid && userSlippageTolerance < 50) {
        slippageError = SlippageError.RiskyLow;
    } else if (slippageInputIsValid && userSlippageTolerance > 500) {
        slippageError = SlippageError.RiskyHigh;
    } else {
        slippageError = undefined;
    }
    var deadlineError;
    if (deadlineInput !== "" && !deadlineInputIsValid) {
        deadlineError = DeadlineError.InvalidInput;
    } else {
        deadlineError = undefined;
    }
    var parseCustomSlippage = function(value) {
        if (value === "" || inputRegex.test((0,utils/* escapeRegExp */.hr)(value))) {
            setSlippageInput(value);
            try {
                var valueAsIntFromRoundedFloat = Number.parseInt((Number.parseFloat(value) * 100).toString());
                if (!Number.isNaN(valueAsIntFromRoundedFloat) && valueAsIntFromRoundedFloat < 5000) {
                    setUserSlippageTolerance(valueAsIntFromRoundedFloat);
                }
            } catch (error) {
                console.error(error);
            }
        }
    };
    var parseCustomDeadline = function(value) {
        setDeadlineInput(value);
        try {
            var valueAsInt = Number.parseInt(value) * 60;
            if (!Number.isNaN(valueAsInt) && valueAsInt > 60 && valueAsInt < THREE_DAYS_IN_SECONDS) {
                setTtl(valueAsInt);
            } else {
                deadlineError = DeadlineError.InvalidInput;
            }
        } catch (error) {
            console.error(error);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        flexDirection: "column",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                flexDirection: "column",
                mb: "24px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        mb: "12px",
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                fontSize: "16px",
                                children: t("noah16")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(QuestionHelper/* default */.Z, {
                                text: t("noah20"),
                                placement: "top-start",
                                ml: "4px"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        flexWrap: "wrap",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                mt: "4px",
                                mr: "10px",
                                ml: "0px",
                                scale: "sm",
                                border: true,
                                onClick: function() {
                                    setSlippageInput("");
                                    setUserSlippageTolerance(50);
                                },
                                variant: userSlippageTolerance === 50 ? "primary" : "tertiary",
                                children: "0.5%"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                mr: "10px",
                                mt: "4px",
                                scale: "sm",
                                border: true,
                                onClick: function() {
                                    setSlippageInput("");
                                    setUserSlippageTolerance(100);
                                },
                                variant: userSlippageTolerance === 100 ? "primary" : "tertiary",
                                children: "1.0%"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                mt: "4px",
                                scale: "sm",
                                border: true,
                                onClick: function() {
                                    setSlippageInput("");
                                    setUserSlippageTolerance(300);
                                },
                                variant: userSlippageTolerance === 300 ? "primary" : "tertiary",
                                children: "3.0%"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                width: "132px",
                                mt: "4px",
                                style: {
                                    border: "1px solid #eee",
                                    borderRadius: 6
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                    alignItems: "center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                            inputMode: "decimal",
                                            pattern: "^[0-9]*[.,]?[0-9]{0,2}$",
                                            // placeholder={(userSlippageTolerance / 100).toFixed(2)}
                                            placeholder: (10 / 100).toFixed(2),
                                            value: slippageInput,
                                            onBlur: function() {
                                                parseCustomSlippage((userSlippageTolerance / 100).toFixed(2));
                                            },
                                            // onBlur={() => {
                                            //   parseCustomSlippage((10 / 100).toFixed(2))
                                            // }}
                                            onChange: function(event) {
                                                if (event.currentTarget.validity.valid) {
                                                    parseCustomSlippage(event.target.value.replace(/,/g, "."));
                                                }
                                            },
                                            isWarning: !slippageInputIsValid,
                                            isSuccess: ![
                                                10,
                                                50,
                                                100
                                            ].includes(userSlippageTolerance)
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            bold: true,
                                            ml: "2px",
                                            mr: "6px",
                                            children: "%"
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    !!slippageError && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        fontSize: "14px",
                        color: slippageError === SlippageError.InvalidInput ? "red" : "#F3841E",
                        mt: "8px",
                        children: slippageError === SlippageError.InvalidInput ? t("Enter a valid slippage percentage") : slippageError === SlippageError.RiskyLow ? t("Your transaction may fail") : t("Your transaction may be frontrun")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                justifyContent: "space-between",
                alignItems: "center",
                mb: "24px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                fontSize: "16px",
                                children: t("Tx deadline (mins)")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(QuestionHelper/* default */.Z, {
                                text: t("noah21"),
                                placement: "top-start",
                                ml: "4px"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            width: "70px",
                            mt: "4px",
                            style: {
                                border: "1px solid #eee",
                                borderRadius: 6
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                inputMode: "numeric",
                                pattern: "^[0-9]+$",
                                isWarning: !!deadlineError,
                                onBlur: function() {
                                    parseCustomDeadline((ttl / 60).toString());
                                },
                                placeholder: (ttl / 60).toString(),
                                value: deadlineInput,
                                onChange: function(event) {
                                    if (event.currentTarget.validity.valid) {
                                        parseCustomDeadline(event.target.value);
                                    }
                                }
                            })
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var TransactionSettings = (SlippageTabs);

// EXTERNAL MODULE: ./packages/uikit/src/components/Message/Message.tsx + 1 modules
var Message = __webpack_require__(67334);
// EXTERNAL MODULE: ./packages/uikit/src/components/Checkbox/Checkbox.tsx + 1 modules
var Checkbox = __webpack_require__(19731);
;// CONCATENATED MODULE: ./src/components/Menu/GlobalSettings/ExpertModal.tsx






var ExpertModal = function(param) {
    var setShowConfirmExpertModal = param.setShowConfirmExpertModal, setShowExpertModeAcknowledgement = param.setShowExpertModeAcknowledgement;
    var ref = (0,_sliced_to_array/* default */.Z)((0,hooks/* useExpertModeManager */.DG)(), 2), toggleExpertMode = ref[1];
    var ref1 = (0,react.useState)(false), isRememberChecked = ref1[0], setIsRememberChecked = ref1[1];
    var t = (0,src/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default */.Z, {
        title: t("Expert Mode"),
        onBack: function() {
            return setShowConfirmExpertModal(false);
        },
        onDismiss: function() {
            return setShowConfirmExpertModal(false);
        },
        headerBackground: "gradients.cardHeader",
        style: {
            width: "418px"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Message/* default */.Z, {
                variant: "warning",
                mb: "24px",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    children: t("Expert mode turns off the 'Confirm' transaction prompt, and allows high slippage trades that often result in bad rates and lost funds.")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                mb: "24px",
                children: t("Only use this mode if you know what you’re doing.")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                alignItems: "center",
                mb: "24px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                        name: "confirmed",
                        type: "checkbox",
                        checked: isRememberChecked,
                        onChange: function() {
                            return setIsRememberChecked(!isRememberChecked);
                        },
                        scale: "sm"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        ml: "10px",
                        color: "textSubtle",
                        style: {
                            userSelect: "none"
                        },
                        children: t("Don’t show this again")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                mb: "8px",
                id: "confirm-expert-mode",
                onClick: function() {
                    // eslint-disable-next-line no-alert
                    if (window.prompt('Please type the word "confirm" to enable expert mode.') === "confirm") {
                        toggleExpertMode();
                        setShowConfirmExpertModal(false);
                        if (isRememberChecked) {
                            setShowExpertModeAcknowledgement(false);
                        }
                    }
                },
                children: t("Turn On Expert Mode")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                variant: "secondary",
                onClick: function() {
                    setShowConfirmExpertModal(false);
                },
                children: t("Cancel")
            })
        ]
    });
};
/* harmony default export */ var GlobalSettings_ExpertModal = (ExpertModal);

// EXTERNAL MODULE: ./src/state/types.ts
var types = __webpack_require__(45101);
// EXTERNAL MODULE: ./src/hooks/useActiveWeb3React.ts
var useActiveWeb3React = __webpack_require__(64011);
;// CONCATENATED MODULE: ./src/components/Menu/GlobalSettings/GasSettings.tsx
/* eslint-disable */ 







var GasSettings = function() {
    var t = (0,src/* useTranslation */.$G)().t;
    var chainId = (0,useActiveWeb3React/* default */.Z)().chainId;
    var ref = (0,_sliced_to_array/* default */.Z)((0,hooks/* useGasPriceManager */.nF)(), 2), gasPrice = ref[0], setGasPrice = ref[1];
    var defaultGasPrice = (0,hooks/* useDefaultGasPrice */.e7)();
    console.log("defaultGasPrice", defaultGasPrice);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        flexDirection: "column",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                mb: "12px",
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        children: t("noah220")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(QuestionHelper/* default */.Z, {
                        text: t("noah219"),
                        placement: "top-start",
                        ml: "4px"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                flexWrap: "wrap",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        mt: "4px",
                        mr: "4px",
                        border: true,
                        scale: "sm",
                        onClick: function() {
                            setGasPrice(types/* GAS_PRICE_GWEI.rpcDefault */.j4.rpcDefault);
                        },
                        variant: gasPrice === types/* GAS_PRICE_GWEI.rpcDefault */.j4.rpcDefault ? "primary" : "tertiary",
                        children: t("noah216") + " " + Number(defaultGasPrice) / Math.pow(10, 9) + " Gwei"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        mt: "4px",
                        mr: "4px",
                        border: true,
                        scale: "sm",
                        onClick: function() {
                            setGasPrice((Number(defaultGasPrice) + Number(defaultGasPrice) * 0.03).toString());
                        // setGasPrice('930000000000')
                        // setGasPrice(GAS_PRICE_GWEI.fast)
                        },
                        variant: gasPrice === (Number(defaultGasPrice) + Number(defaultGasPrice) * 0.03).toString() ? "primary" : "tertiary",
                        children: (Number(defaultGasPrice) + Number(defaultGasPrice) * 0.03) / Math.pow(10, 9) + " Gwei"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        mr: "4px",
                        mt: "4px",
                        border: true,
                        scale: "sm",
                        onClick: function() {
                            // setGasPrice(GAS_PRICE_GWEI.instant)
                            // setGasPrice((Number(defaultGasPrice) + Number(parseUnits('60', 'gwei').toString())).toString())
                            setGasPrice((Number(defaultGasPrice) + Number(defaultGasPrice) * 0.06).toString());
                        },
                        variant: // gasPrice === (Number(defaultGasPrice) + Number(parseUnits('60', 'gwei').toString())).toString()
                        gasPrice === (Number(defaultGasPrice) + Number(defaultGasPrice) * 0.06).toString() ? "primary" : "tertiary",
                        children: (Number(defaultGasPrice) + Number(defaultGasPrice) * 0.06) / Math.pow(10, 9) + " Gwei"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var GlobalSettings_GasSettings = (GasSettings);

// EXTERNAL MODULE: ./src/components/Menu/GlobalSettings/types.ts
var GlobalSettings_types = __webpack_require__(47431);
;// CONCATENATED MODULE: ./src/components/Menu/GlobalSettings/SettingsModal.tsx





function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-direction: column;\n  height: auto;\n  ",
        " {\n    max-height: 90vh;\n  }\n  ",
        " {\n    max-height: none;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}












var ScrollableContainer = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-d05b5a3f-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.xs;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
});
var withCustomOnDismiss = function(Component) {
    return function(_param) {
        var onDismiss = _param.onDismiss, customOnDismiss = _param.customOnDismiss, mode = _param.mode, props = _object_without_properties(_param, [
            "onDismiss",
            "customOnDismiss",
            "mode"
        ]);
        var handleDismiss = useCallback(function() {
            onDismiss === null || onDismiss === void 0 ? void 0 : onDismiss();
            if (customOnDismiss) {
                customOnDismiss();
            }
        }, [
            customOnDismiss,
            onDismiss
        ]);
        return /*#__PURE__*/ _jsx(Component, _object_spread_props(_object_spread({}, props), {
            mode: mode,
            onDismiss: handleDismiss
        }));
    };
};
var SettingsModal = function(param) {
    var onDismiss = param.onDismiss, mode = param.mode;
    var ref = (0,react.useState)(false), showConfirmExpertModal = ref[0], setShowConfirmExpertModal = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,hooks/* useUserExpertModeAcknowledgementShow */.wX)(), 2), showExpertModeAcknowledgement = ref1[0], setShowExpertModeAcknowledgement = ref1[1];
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,hooks/* useUserSingleHopOnly */.RO)(), 2), singleHopOnly = ref2[0], setSingleHopOnly = ref2[1];
    var t = (0,src/* useTranslation */.$G)().t;
    var ref3 = (0,useTheme/* default */.ZP)(), isDark = ref3.isDark, setTheme = ref3.setTheme;
    if (showConfirmExpertModal) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalSettings_ExpertModal, {
            setShowConfirmExpertModal: setShowConfirmExpertModal,
            onDismiss: onDismiss,
            setShowExpertModeAcknowledgement: setShowExpertModeAcknowledgement
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
        title: t("noah15"),
        onDismiss: onDismiss,
        bodyPadding: "0 24px 24px 24px",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ScrollableContainer, {
            style: {
                paddingTop: 0
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                        pb: "24px",
                        flexDirection: "column",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalSettings_GasSettings, {})
                    })
                }),
                mode === GlobalSettings_types/* SettingsMode.SWAP_LIQUIDITY */.a.SWAP_LIQUIDITY && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                            pt: "0",
                            flexDirection: "column",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TransactionSettings, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                            justifyContent: "space-between",
                            alignItems: "center",
                            mb: "24px",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                    alignItems: "center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            fontSize: "16px",
                                            children: t("noah18")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(QuestionHelper/* default */.Z, {
                                            text: t("noah22"),
                                            placement: "top-start",
                                            ml: "4px"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Toggle/* default */.Z, {
                                    id: "toggle-disable-multihop-button",
                                    checked: singleHopOnly,
                                    scale: "sm",
                                    onChange: function() {
                                        setSingleHopOnly(!singleHopOnly);
                                    }
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var GlobalSettings_SettingsModal = (SettingsModal);

;// CONCATENATED MODULE: ./src/components/Menu/GlobalSettings/index.tsx




var GlobalSettings = function(param) {
    var color = param.color, _mr = param.mr, mr = _mr === void 0 ? "8px" : _mr, mode = param.mode;
    var ref = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalSettings_SettingsModal, {
        mode: mode
    })), 1), onPresentSettingsModal = ref[0];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
            onClick: onPresentSettingsModal,
            variant: "text",
            scale: "sm",
            mr: mr,
            id: "open-settings-dialog-button-".concat(mode),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: "/images/small-img/setting.png",
                width: 20,
                height: 20,
                alt: "setting"
            })
        })
    });
};
/* harmony default export */ var Menu_GlobalSettings = (GlobalSettings);


/***/ }),

/***/ 47431:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ SettingsMode; }
/* harmony export */ });
var SettingsMode;
(function(SettingsMode) {
    SettingsMode["GLOBAL"] = "GLOBAL";
    SettingsMode["SWAP_LIQUIDITY"] = "SWAP_LIQUIDITY";
})(SettingsMode || (SettingsMode = {}));


/***/ }),

/***/ 4003:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bq": function() { return /* binding */ ONE_DAY_UNIX; },
/* harmony export */   "Tb": function() { return /* binding */ ONE_HOUR_SECONDS; },
/* harmony export */   "si": function() { return /* binding */ ITEMS_PER_INFO_TABLE_PAGE; }
/* harmony export */ });
/* unused harmony exports MINIMUM_SEARCH_CHARACTERS, WEEKS_IN_YEAR, TOTAL_FEE, LP_HOLDERS_FEE, TREASURY_FEE, BUYBACK_FEE, PCS_V2_START, TOKEN_BLACKLIST */
var MINIMUM_SEARCH_CHARACTERS = 2;
var WEEKS_IN_YEAR = 52.1429;
var TOTAL_FEE = 0.003;
var LP_HOLDERS_FEE = 0.0017;
var TREASURY_FEE = 0.000225;
var BUYBACK_FEE = 0.000575;
var PCS_V2_START = 1619136000 // April 23, 2021, 12:00:00 AM
;
var ONE_DAY_UNIX = 86400 // 24h * 60m * 60s
;
var ONE_HOUR_SECONDS = 3600;
var ITEMS_PER_INFO_TABLE_PAGE = 10;
// These tokens are either incorrectly priced or have some other issues that spoil the query data
// None of them present any interest as they have almost 0 daily trade volume
var TOKEN_BLACKLIST = (/* unused pure expression or super */ null && ([
    // These ones are copied from v1 info
    "0x495c7f3a713870f68f8b418b355c085dfdc412c3",
    "0xc3761eb917cd790b30dad99f6cc5b4ff93c4f9ea",
    "0xe31debd7abff90b06bca21010dd860d8701fd901",
    "0xfc989fbb6b3024de5ca0144dc23c18a063942ac1",
    "0xe40fc6ff5f2895b44268fd2e1a421e07f567e007",
    "0xfd158609228b43aa380140b46fff3cdf9ad315de",
    "0xc00af6212fcf0e6fd3143e692ccd4191dc308bea",
    "0x205969b3ad459f7eba0dee07231a6357183d3fb6",
    "0x0bd67d358636fd7b0597724aa4f20beedbf3073a",
    "0xedf5d2a561e8a3cb5a846fbce24d2ccd88f50075",
    "0x702b0789a3d4dade1688a0c8b7d944e5ba80fc30",
    "0x041929a760d7049edaef0db246fa76ec975e90cc",
    "0xba098df8c6409669f5e6ec971ac02cd5982ac108",
    "0x1bbed115afe9e8d6e9255f18ef10d43ce6608d94",
    "0xe99512305bf42745fae78003428dcaf662afb35d",
    "0xbE609EAcbFca10F6E5504D39E3B113F808389056",
    "0x847daf9dfdc22d5c61c4a857ec8733ef5950e82e",
    "0xdbf8913dfe14536c0dae5dd06805afb2731f7e7b",
    // These ones are newly found
    "0xF1D50dB2C40b63D2c598e2A808d1871a40b1E653",
    "0x4269e4090ff9dfc99d8846eb0d42e67f01c3ac8b", 
]));


/***/ }),

/***/ 23715:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "mP": function() { return /* binding */ useIsTransactionUnsupported; },
  "uK": function() { return /* binding */ useIsTransactionWarning; },
  "AU": function() { return /* binding */ useTradeExactIn; },
  "in": function() { return /* binding */ useTradeExactOut; }
});

// UNUSED EXPORTS: useAllCommonPairs

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./src/config/constants/exchange.ts
var exchange = __webpack_require__(19838);
;// CONCATENATED MODULE: ./src/utils/trades.ts

// returns whether tradeB is better than tradeA by at least a threshold percentage amount
function isTradeBetter(tradeA, tradeB) {
    var minimumDelta = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : exchange/* ZERO_PERCENT */.fI;
    if (tradeA && !tradeB) return false;
    if (tradeB && !tradeA) return true;
    if (!tradeA || !tradeB) return undefined;
    if (tradeA.tradeType !== tradeB.tradeType || !tradeA.inputAmount.currency.equals(tradeB.inputAmount.currency) || !tradeA.outputAmount.currency.equals(tradeB.outputAmount.currency)) {
        throw new Error("Trades are not comparable");
    }
    if (minimumDelta.equalTo(exchange/* ZERO_PERCENT */.fI)) {
        return tradeA.executionPrice.lessThan(tradeB.executionPrice);
    }
    return tradeA.executionPrice.asFraction.multiply(minimumDelta.add(exchange/* ONE_HUNDRED_PERCENT */.yC)).lessThan(tradeB.executionPrice);
}
/* harmony default export */ var trades = ((/* unused pure expression or super */ null && (isTradeBetter)));

// EXTERNAL MODULE: ./packages/swap-sdk/src/index.ts + 20 modules
var src = __webpack_require__(79331);
// EXTERNAL MODULE: ./node_modules/lodash/flatMap.js
var flatMap = __webpack_require__(94654);
var flatMap_default = /*#__PURE__*/__webpack_require__.n(flatMap);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/hooks/useActiveWeb3React.ts
var useActiveWeb3React = __webpack_require__(64011);
// EXTERNAL MODULE: ./src/state/user/hooks/index.tsx
var hooks = __webpack_require__(68605);
// EXTERNAL MODULE: ./src/hooks/usePairs.ts
var usePairs = __webpack_require__(84915);
// EXTERNAL MODULE: ./src/utils/wrappedCurrency.ts
var wrappedCurrency = __webpack_require__(53854);
// EXTERNAL MODULE: ./src/hooks/Tokens.ts
var Tokens = __webpack_require__(86435);
// EXTERNAL MODULE: ./src/state/user/hooks/useUserAddedTokens.ts
var useUserAddedTokens = __webpack_require__(44797);
;// CONCATENATED MODULE: ./src/hooks/Trades.ts
/* eslint-disable no-param-reassign */ /* eslint-disable */ 












// import { useCommonTokens } from './useCommonTokens'

function useAllCommonPairs(currencyA, currencyB, listData) {
    var chainId = (0,useActiveWeb3React/* default */.Z)().chainId;
    var ref = (0,_sliced_to_array/* default */.Z)(chainId ? [
        (0,wrappedCurrency/* wrappedCurrency */.pu)(currencyA, chainId),
        (0,wrappedCurrency/* wrappedCurrency */.pu)(currencyB, chainId)
    ] : [
        undefined,
        undefined
    ], 2), tokenA = ref[0], tokenB = ref[1];
    // const defaultTokens = useAllTokens()
    // const [allTokens, setAllTokens] = useState<any>({}) // 初始数据设为null或其他默认值
    var userAddedTokens = (0,useUserAddedTokens/* default */.Z)();
    // const allTokens = useCommonTokens()
    // console.log('最终的得到✌🏻✌🏻✌🏻✌🏻✌🏻✌🏻✌🏻', listData)
    var allTokens = (0,_object_spread/* default */.Z)({}, listData, userAddedTokens);
    // useEffect(() => {
    //   const data = useCommonTokens()
    //   setAllTokens(data)
    // }, [currencyA, currencyB])
    // const allTokens2 = JSON.parse(localStorage.getItem('listData'))
    // const objGOGO = listToTokenMap(allTokens2)
    // console.log('Trades.ts', '执行了getCoinList')
    // console.log('allTokens', allTokens)
    var coinArr = [] // 这里的coinArr表示两两配对的币种数据, 之前是用getCoinList全部币种做配对
    ;
    if (false) {} else {
        // Wrapped、Tether USD (EOS)、NOAH、Tether USD、Dai Stablecoin、USD Coin
        coinArr = [
            "0xc00592aA41D32D137dC480d9f6d0Df19b860104F",
            "0x2a3b2d64960036de519dC4a45CAfd532Bfa99Ff0",
            "0x33B57dC70014FD7AA6e1ed3080eeD2B619632B8e",
            "0xfA9343C3897324496A05fC75abeD6bAC29f8A40f",
            "0x818ec0A7Fe18Ff94269904fCED6AE3DaE6d6dC0b",
            "0x765277EebeCA2e31912C9946eAe1021199B39C61", 
        ];
    }
    // console.log(process.env.NODE_ENV)
    // EOS、USDT、USDC、DAI (测试服)
    // const coinArr = [
    //   '0x6cCC5AD199bF1C64b50f6E7DD530d71402402EB6',
    //   '0xCE47ff7bEb3ee245A3274dA3db50FC795b2fB1e4',
    //   '0xb3854c53E7415963E1309520965903Bc52B2bE81',
    //   '0x837aF628eBb4b98bD581954e50b1A07cEcd721FB',
    // ]
    var filteredObj = coinArr.reduce(function(acc, coinAddress) {
        if (allTokens[coinAddress]) {
            acc[coinAddress] = allTokens[coinAddress];
        }
        return acc;
    }, {});
    // console.log('filteredObjfilteredObjfilteredObj', filteredObj);
    var aaa = Object.keys(filteredObj).map(function(i) {
        return filteredObj[i];
    });
    // console.log('aaa', aaa)
    var bases = (0,react.useMemo)(function() {
        var ref, ref1;
        if (!chainId) return [];
        var common = aaa !== null && aaa !== void 0 ? aaa : [];
        var ref2;
        var additionalA = tokenA ? (ref2 = (ref = exchange/* ADDITIONAL_BASES */.ck[chainId]) === null || ref === void 0 ? void 0 : ref[tokenA.address]) !== null && ref2 !== void 0 ? ref2 : [] : [];
        var ref3;
        var additionalB = tokenB ? (ref3 = (ref1 = exchange/* ADDITIONAL_BASES */.ck[chainId]) === null || ref1 === void 0 ? void 0 : ref1[tokenB.address]) !== null && ref3 !== void 0 ? ref3 : [] : [];
        return (0,_to_consumable_array/* default */.Z)(common).concat((0,_to_consumable_array/* default */.Z)(additionalA), (0,_to_consumable_array/* default */.Z)(additionalB));
    // if(singleHopOnly){
    //   return [...additionalA, ...additionalB]
    // } else {
    //   return [...common, ...additionalA, ...additionalB]
    // }
    }, [
        chainId,
        tokenA,
        tokenB
    ]);
    var basePairs = (0,react.useMemo)(function() {
        return flatMap_default()(bases, function(base) {
            return bases.map(function(otherBase) {
                return [
                    base,
                    otherBase
                ];
            });
        });
    }, [
        bases
    ]);
    var allPairCombinations = (0,react.useMemo)(function() {
        return tokenA && tokenB ? [
            // the direct pair
            [
                tokenA,
                tokenB
            ], 
        ].concat(// token A against all bases
        (0,_to_consumable_array/* default */.Z)(bases.map(function(base) {
            return [
                tokenA,
                base
            ];
        })), // token B against all bases
        (0,_to_consumable_array/* default */.Z)(bases.map(function(base) {
            return [
                tokenB,
                base
            ];
        })), // each base against all bases
        (0,_to_consumable_array/* default */.Z)(basePairs)).filter(function(tokens) {
            return Boolean(tokens[0] && tokens[1]);
        }).filter(function(param) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), t0 = _param[0], t1 = _param[1];
            return t0.address !== t1.address;
        }).filter(function(param) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), tokenA_ = _param[0], tokenB_ = _param[1];
            if (!chainId) return true;
            var customBases = exchange/* CUSTOM_BASES */.IP[chainId];
            var customBasesA = customBases === null || customBases === void 0 ? void 0 : customBases[tokenA_.address];
            var customBasesB = customBases === null || customBases === void 0 ? void 0 : customBases[tokenB_.address];
            if (!customBasesA && !customBasesB) return true;
            if (customBasesA && !customBasesA.find(function(base) {
                return tokenB_.equals(base);
            })) return false;
            if (customBasesB && !customBasesB.find(function(base) {
                return tokenA_.equals(base);
            })) return false;
            return true;
        }) : [];
    }, [
        tokenA,
        tokenB,
        bases,
        basePairs,
        chainId
    ]);
    // console.log('allPairCombinations', allPairCombinations)
    var allPairs = (0,usePairs/* usePairs */.z$)(allPairCombinations);
    // console.log('usePairs', usePairs)
    // only pass along valid pairs, non-duplicated pairs
    return (0,react.useMemo)(function() {
        return Object.values(allPairs// filter out invalid pairs
        .filter(function(result) {
            return Boolean(result[0] === usePairs/* PairState.EXISTS */._G.EXISTS && result[1]);
        })// filter out duplicated pairs
        .reduce(function(memo, param) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), curr = _param[1];
            var _address;
            memo[curr.liquidityToken.address] = (_address = memo[curr.liquidityToken.address]) !== null && _address !== void 0 ? _address : curr;
            return memo;
        }, {}));
    }, [
        allPairs
    ]);
}
var MAX_HOPS = 3;
/**
 * Returns the best trade for the exact amount of tokens in to the given token out
 */ function useTradeExactIn(currencyAmountIn, currencyOut, listData) {
    // console.log('useTradeExactIn', '触发useAllCommonPairs')
    // console.log('👿👿👿👿👿👿👿', listData)
    var allowedPairs = useAllCommonPairs(currencyAmountIn === null || currencyAmountIn === void 0 ? void 0 : currencyAmountIn.currency, currencyOut, listData);
    // console.log(allowedPairs, 'allowedPairsallowedPairs')
    var ref = (0,_sliced_to_array/* default */.Z)((0,hooks/* useUserSingleHopOnly */.RO)(), 1), singleHopOnly = ref[0];
    return (0,react.useMemo)(function() {
        if (currencyAmountIn && currencyOut && allowedPairs.length > 0) {
            if (singleHopOnly) {
                var ref;
                return (ref = src/* Trade.bestTradeExactIn */.ho.bestTradeExactIn(allowedPairs, currencyAmountIn, currencyOut, {
                    maxHops: 1,
                    maxNumResults: 1
                })[0]) !== null && ref !== void 0 ? ref : null;
            }
            // search through trades with varying hops, find best trade out of them
            var bestTradeSoFar = null;
            for(var i = 1; i <= MAX_HOPS; i++){
                var ref1;
                var currentTrade = (ref1 = src/* Trade.bestTradeExactIn */.ho.bestTradeExactIn(allowedPairs, currencyAmountIn, currencyOut, {
                    maxHops: i,
                    maxNumResults: 1
                })[0]) !== null && ref1 !== void 0 ? ref1 : null;
                // if current trade is best yet, save it
                if (isTradeBetter(bestTradeSoFar, currentTrade, exchange/* BETTER_TRADE_LESS_HOPS_THRESHOLD */.Ru)) {
                    bestTradeSoFar = currentTrade;
                }
            }
            return bestTradeSoFar;
        }
        return null;
    }, [
        allowedPairs,
        currencyAmountIn,
        currencyOut,
        singleHopOnly
    ]);
}
/**
 * Returns the best trade for the token in to the exact amount of token out
 */ function useTradeExactOut(currencyIn, currencyAmountOut, listData) {
    // console.log('useTradeExactOut', '触发useAllCommonPairs')
    // console.log('👿👿👿👿👿👿👿', listData)
    var allowedPairs = useAllCommonPairs(currencyIn, currencyAmountOut === null || currencyAmountOut === void 0 ? void 0 : currencyAmountOut.currency, listData);
    var ref = (0,_sliced_to_array/* default */.Z)((0,hooks/* useUserSingleHopOnly */.RO)(), 1), singleHopOnly = ref[0];
    return (0,react.useMemo)(function() {
        if (currencyIn && currencyAmountOut && allowedPairs.length > 0) {
            if (singleHopOnly) {
                var ref;
                return (ref = src/* Trade.bestTradeExactOut */.ho.bestTradeExactOut(allowedPairs, currencyIn, currencyAmountOut, {
                    maxHops: 1,
                    maxNumResults: 1
                })[0]) !== null && ref !== void 0 ? ref : null;
            }
            // search through trades with varying hops, find best trade out of them
            var bestTradeSoFar = null;
            for(var i = 1; i <= MAX_HOPS; i++){
                var ref1;
                var currentTrade = (ref1 = src/* Trade.bestTradeExactOut */.ho.bestTradeExactOut(allowedPairs, currencyIn, currencyAmountOut, {
                    maxHops: i,
                    maxNumResults: 1
                })[0]) !== null && ref1 !== void 0 ? ref1 : null;
                if (isTradeBetter(bestTradeSoFar, currentTrade, exchange/* BETTER_TRADE_LESS_HOPS_THRESHOLD */.Ru)) {
                    bestTradeSoFar = currentTrade;
                }
            }
            return bestTradeSoFar;
        }
        return null;
    }, [
        currencyIn,
        currencyAmountOut,
        allowedPairs,
        singleHopOnly
    ]);
}
function useIsTransactionUnsupported(currencyIn, currencyOut) {
    var unsupportedTokens = (0,Tokens/* useUnsupportedTokens */.l6)();
    var chainId = (0,useActiveWeb3React/* default */.Z)().chainId;
    var tokenIn = (0,wrappedCurrency/* wrappedCurrency */.pu)(currencyIn, chainId);
    var tokenOut = (0,wrappedCurrency/* wrappedCurrency */.pu)(currencyOut, chainId);
    // if unsupported list loaded & either token on list, mark as unsupported
    if (unsupportedTokens) {
        if (tokenIn && Object.keys(unsupportedTokens).includes(tokenIn.address)) {
            return true;
        }
        if (tokenOut && Object.keys(unsupportedTokens).includes(tokenOut.address)) {
            return true;
        }
    }
    return false;
}
function useIsTransactionWarning(currencyIn, currencyOut) {
    var unsupportedTokens = (0,Tokens/* useWarningTokens */.zd)();
    var chainId = (0,useActiveWeb3React/* default */.Z)().chainId;
    var tokenIn = (0,wrappedCurrency/* wrappedCurrency */.pu)(currencyIn, chainId);
    var tokenOut = (0,wrappedCurrency/* wrappedCurrency */.pu)(currencyOut, chainId);
    // if unsupported list loaded & either token on list, mark as unsupported
    if (unsupportedTokens) {
        if (tokenIn && Object.keys(unsupportedTokens).includes(tokenIn.address)) {
            return true;
        }
        if (tokenOut && Object.keys(unsupportedTokens).includes(tokenOut.address)) {
            return true;
        }
    }
    return false;
}


/***/ }),

/***/ 84915:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_G": function() { return /* binding */ PairState; },
/* harmony export */   "yX": function() { return /* binding */ usePair; },
/* harmony export */   "z$": function() { return /* binding */ usePairs; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(828);
/* harmony import */ var _noahswap_sdk__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79331);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var config_abi_INoahPair_json__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87191);
/* harmony import */ var _ethersproject_abi__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8198);
/* harmony import */ var hooks_useActiveWeb3React__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(64011);
/* harmony import */ var _state_multicall_hooks__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(91001);
/* harmony import */ var _utils_wrappedCurrency__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(53854);








var PAIR_INTERFACE = new _ethersproject_abi__WEBPACK_IMPORTED_MODULE_6__/* .Interface */ .vU(config_abi_INoahPair_json__WEBPACK_IMPORTED_MODULE_2__);
var PairState;
(function(PairState) {
    PairState[PairState["LOADING"] = 0] = "LOADING";
    PairState[PairState["NOT_EXISTS"] = 1] = "NOT_EXISTS";
    PairState[PairState["EXISTS"] = 2] = "EXISTS";
    PairState[PairState["INVALID"] = 3] = "INVALID";
})(PairState || (PairState = {}));
function usePairs(currencies) {
    var chainId = (0,hooks_useActiveWeb3React__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)().chainId;
    var tokens = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return currencies.map(function(param) {
            var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(param, 2), currencyA = _param[0], currencyB = _param[1];
            return [
                (0,_utils_wrappedCurrency__WEBPACK_IMPORTED_MODULE_5__/* .wrappedCurrency */ .pu)(currencyA, chainId),
                (0,_utils_wrappedCurrency__WEBPACK_IMPORTED_MODULE_5__/* .wrappedCurrency */ .pu)(currencyB, chainId), 
            ];
        });
    }, [
        chainId,
        currencies
    ]);
    var pairAddresses = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return tokens.map(function(param) {
            var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(param, 2), tokenA = _param[0], tokenB = _param[1];
            try {
                return tokenA && tokenB && !tokenA.equals(tokenB) ? _noahswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Pair.getAddress */ .sO.getAddress(tokenA, tokenB) : undefined;
            } catch (error) {
                // Debug Invariant failed related to this line
                console.error(error.msg, "- pairAddresses: ".concat(tokenA === null || tokenA === void 0 ? void 0 : tokenA.address, "-").concat(tokenB === null || tokenB === void 0 ? void 0 : tokenB.address), "chainId: ".concat(tokenA === null || tokenA === void 0 ? void 0 : tokenA.chainId));
                return undefined;
            }
        });
    }, [
        tokens
    ]);
    // console.log('pairAddresses', pairAddresses)
    var results = (0,_state_multicall_hooks__WEBPACK_IMPORTED_MODULE_4__/* .useMultipleContractSingleData */ ._Y)(pairAddresses, PAIR_INTERFACE, "getReserves");
    return (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return results.map(function(result, i) {
            var reserves = result.result, loading = result.loading;
            var tokenA = tokens[i][0];
            var tokenB = tokens[i][1];
            if (loading) return [
                PairState.LOADING,
                null
            ];
            if (!tokenA || !tokenB || tokenA.equals(tokenB)) return [
                PairState.INVALID,
                null
            ];
            if (!reserves) return [
                PairState.NOT_EXISTS,
                null
            ];
            var reserve0 = reserves.reserve0, reserve1 = reserves.reserve1;
            var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(tokenA.sortsBefore(tokenB) ? [
                tokenA,
                tokenB
            ] : [
                tokenB,
                tokenA
            ], 2), token0 = ref[0], token1 = ref[1];
            return [
                PairState.EXISTS,
                new _noahswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Pair */ .sO(_noahswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .CurrencyAmount.fromRawAmount */ .ih.fromRawAmount(token0, reserve0.toString()), _noahswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .CurrencyAmount.fromRawAmount */ .ih.fromRawAmount(token1, reserve1.toString())), 
            ];
        });
    }, [
        results,
        tokens
    ]);
}
function usePair(tokenA, tokenB) {
    var pairCurrencies = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return [
            [
                tokenA,
                tokenB
            ]
        ];
    }, [
        tokenA,
        tokenB
    ]);
    return usePairs(pairCurrencies)[0];
}


/***/ }),

/***/ 12788:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "jj": function() { return /* binding */ useDefaultsFromURLSearch; },
  "SM": function() { return /* binding */ useDerivedSwapInfo; },
  "aT": function() { return /* binding */ useLPApr; },
  "dU": function() { return /* binding */ useSwapState; }
});

// UNUSED EXPORTS: queryParametersToSwapState, useFetchPairPrices, useSingleTokenSwapInfo

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var src_async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var src_define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./packages/wagmi/src/index.ts + 3 modules
var src = __webpack_require__(67539);
// EXTERNAL MODULE: ./packages/swap-sdk/src/index.ts + 20 modules
var swap_sdk_src = __webpack_require__(79331);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/config/constants/index.ts + 2 modules
var constants = __webpack_require__(68274);
// EXTERNAL MODULE: ./src/config/constants/exchange.ts
var exchange = __webpack_require__(19838);
// EXTERNAL MODULE: ./node_modules/swr/immutable/dist/index.mjs
var dist = __webpack_require__(49770);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./src/hooks/useActiveWeb3React.ts
var useActiveWeb3React = __webpack_require__(64011);
// EXTERNAL MODULE: ./src/hooks/Trades.ts + 1 modules
var Trades = __webpack_require__(23715);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./packages/localization/src/index.tsx + 4 modules
var localization_src = __webpack_require__(65208);
// EXTERNAL MODULE: ./src/utils/index.ts
var utils = __webpack_require__(93293);
// EXTERNAL MODULE: ./src/hooks/useNativeCurrency.ts
var useNativeCurrency = __webpack_require__(70176);
// EXTERNAL MODULE: ./src/utils/exchange.ts + 1 modules
var utils_exchange = __webpack_require__(42658);
// EXTERNAL MODULE: ./src/utils/getLpAddress.ts
var utils_getLpAddress = __webpack_require__(32323);
// EXTERNAL MODULE: ./src/utils/tryParseAmount.ts
var utils_tryParseAmount = __webpack_require__(97938);
// EXTERNAL MODULE: ./src/state/index.ts + 38 modules
var state = __webpack_require__(81002);
// EXTERNAL MODULE: ./src/state/wallet/hooks.ts
var hooks = __webpack_require__(71900);
// EXTERNAL MODULE: ./src/state/swap/actions.ts
var actions = __webpack_require__(70193);
// EXTERNAL MODULE: ./src/state/user/hooks/index.tsx
var user_hooks = __webpack_require__(68605);
;// CONCATENATED MODULE: ./src/utils/requestWithTimeout.ts
var requestWithTimeout = function(graphQLClient, request, variables) {
    var timeout = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 30000;
    return Promise.race([
        variables ? graphQLClient.request(request, variables) : graphQLClient.request(request),
        new Promise(function(_, reject) {
            setTimeout(function() {
                reject(new Error("Request timed out after ".concat(timeout, " milliseconds")));
            }, timeout);
        }), 
    ]);
};
/* harmony default export */ var utils_requestWithTimeout = (requestWithTimeout);

// EXTERNAL MODULE: ./src/config/constants/endpoints.ts
var endpoints = __webpack_require__(85906);
// EXTERNAL MODULE: ./node_modules/graphql-request/dist/index.js
var graphql_request_dist = __webpack_require__(28687);
;// CONCATENATED MODULE: ./src/utils/graphql.ts
/* provided dependency */ var process = __webpack_require__(34155);


// Extra headers
// Mostly for dev environment
// No production env check since production preview might also need them
var getGQLHeaders = function(endpoint) {
    if (endpoint === endpoints/* INFO_CLIENT */.JY) {
        return {
            "X-Sf": process.env.NEXT_PUBLIC_SF_HEADER || // hack for inject CI secret on window
             true && // @ts-ignore
            window.sfHeader
        };
    }
    return undefined;
};
var infoClient = new graphql_request_dist.GraphQLClient(endpoints/* INFO_CLIENT */.JY, {
    headers: getGQLHeaders(endpoints/* INFO_CLIENT */.JY)
});
var infoServerClient = new graphql_request_dist.GraphQLClient(endpoints/* INFO_CLIENT */.JY, {
    headers: {
        "X-Sf": process.env.SF_HEADER
    },
    timeout: 5000
});
var bitQueryServerClient = new graphql_request_dist.GraphQLClient("", {
    headers: {
        // only server, no `NEXT_PUBLIC` not going to expose in client
        "X-API-KEY": process.env.BIT_QUERY_HEADER
    },
    timeout: 5000
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
;// CONCATENATED MODULE: ./src/state/swap/queries/lastPairDayId.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query lastPairDayId($pairId: String) {\n    pairDayDatas(first: 1, where: { pairAddress: $pairId }, orderBy: date, orderDirection: desc) {\n      id\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var lastPairDayId = (0,graphql_request_dist.gql)(_templateObject());
/* harmony default export */ var queries_lastPairDayId = (lastPairDayId);

;// CONCATENATED MODULE: ./src/state/swap/queries/pairHourDatas.ts

function pairHourDatas_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query pairHourDatas($pairId: String, $first: Int) {\n    pairHourDatas(first: $first, where: { pair: $pairId }, orderBy: hourStartUnix, orderDirection: desc) {\n      id\n      hourStartUnix\n      reserve0\n      reserve1\n      reserveUSD\n      pair {\n        token0 {\n          id\n        }\n        token1 {\n          id\n        }\n      }\n    }\n  }\n"
    ]);
    pairHourDatas_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var pairHourDatas = (0,graphql_request_dist.gql)(pairHourDatas_templateObject());
/* harmony default export */ var queries_pairHourDatas = (pairHourDatas);

;// CONCATENATED MODULE: ./src/state/swap/queries/pairDayDatasByIdsQuery.ts

function pairDayDatasByIdsQuery_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query pairDayDatasByIdsQuery($pairIds: [String]) {\n    pairDayDatas(where: { id_in: $pairIds }, orderBy: date, orderDirection: desc) {\n      id\n      date\n      reserve0\n      reserve1\n      reserveUSD\n      pairAddress {\n        token0 {\n          id\n        }\n        token1 {\n          id\n        }\n      }\n    }\n  }\n"
    ]);
    pairDayDatasByIdsQuery_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var pairDayDatasByIdsQuery = (0,graphql_request_dist.gql)(pairDayDatasByIdsQuery_templateObject());
/* harmony default export */ var queries_pairDayDatasByIdsQuery = (pairDayDatasByIdsQuery);

;// CONCATENATED MODULE: ./src/state/swap/types.ts
var types_PairDataTimeWindowEnum;
(function(PairDataTimeWindowEnum) {
    PairDataTimeWindowEnum[PairDataTimeWindowEnum["DAY"] = 0] = "DAY";
    PairDataTimeWindowEnum[PairDataTimeWindowEnum["WEEK"] = 1] = "WEEK";
    PairDataTimeWindowEnum[PairDataTimeWindowEnum["MONTH"] = 2] = "MONTH";
    PairDataTimeWindowEnum[PairDataTimeWindowEnum["YEAR"] = 3] = "YEAR";
})(types_PairDataTimeWindowEnum || (types_PairDataTimeWindowEnum = {}));

;// CONCATENATED MODULE: ./src/state/swap/fetch/constants.ts


var _obj;
// Specifies the amount of data points to query for specific time window
var timeWindowIdsCountMapping = (_obj = {}, (0,src_define_property/* default */.Z)(_obj, types_PairDataTimeWindowEnum.DAY, 24), (0,src_define_property/* default */.Z)(_obj, types_PairDataTimeWindowEnum.WEEK, 28), (0,src_define_property/* default */.Z)(_obj, types_PairDataTimeWindowEnum.MONTH, 30), (0,src_define_property/* default */.Z)(_obj, types_PairDataTimeWindowEnum.YEAR, 24), _obj);
var _obj1;
// How many StreamingFast ids to skip when querying the data
var timeWindowGapMapping = (_obj1 = {}, (0,src_define_property/* default */.Z)(_obj1, types_PairDataTimeWindowEnum.DAY, null), (0,src_define_property/* default */.Z)(_obj1, types_PairDataTimeWindowEnum.WEEK, 6), (0,src_define_property/* default */.Z)(_obj1, types_PairDataTimeWindowEnum.MONTH, 1), (0,src_define_property/* default */.Z)(_obj1, types_PairDataTimeWindowEnum.YEAR, 15), _obj1);

// EXTERNAL MODULE: ./node_modules/lodash/times.js
var times = __webpack_require__(98913);
var times_default = /*#__PURE__*/__webpack_require__.n(times);
;// CONCATENATED MODULE: ./src/state/swap/fetch/utils.ts



var getPairSequentialId = function(param) {
    var id = param.id, pairId = param.pairId;
    return id.replace("".concat(pairId, "-"), "");
};
var getIdsByTimeWindow = function(param) {
    var pairAddress = param.pairAddress, pairLastId = param.pairLastId, timeWindow = param.timeWindow, idsCount = param.idsCount;
    var pairLastIdAsNumber = Number(pairLastId);
    if (timeWindow === types_PairDataTimeWindowEnum.DAY) {
        return [];
    }
    return times_default()(idsCount, function(value) {
        return "".concat(pairAddress, "-").concat(pairLastIdAsNumber - value * timeWindowGapMapping[timeWindow]);
    });
};
var utils_pairHasEnoughLiquidity = function(data, timeWindow) {
    var liquidityThreshold = 10000;
    switch(timeWindow){
        case PairDataTimeWindowEnum.DAY:
        case PairDataTimeWindowEnum.WEEK:
            {
                var ref, ref1;
                var ref2;
                var amountOfDataPoints = (ref2 = data === null || data === void 0 ? void 0 : (ref = data.pairHourDatas) === null || ref === void 0 ? void 0 : ref.length) !== null && ref2 !== void 0 ? ref2 : 1;
                var totalUSD = data === null || data === void 0 ? void 0 : (ref1 = data.pairHourDatas) === null || ref1 === void 0 ? void 0 : ref1.reduce(function(totalLiquidity, fetchPairEntry) {
                    return totalLiquidity + parseFloat(fetchPairEntry.reserveUSD);
                }, 0);
                return totalUSD / amountOfDataPoints > liquidityThreshold;
            }
        case PairDataTimeWindowEnum.MONTH:
        case PairDataTimeWindowEnum.YEAR:
            {
                var ref3, ref4;
                var ref5;
                var amountOfDataPoints1 = (ref5 = data === null || data === void 0 ? void 0 : (ref3 = data.pairDayDatas) === null || ref3 === void 0 ? void 0 : ref3.length) !== null && ref5 !== void 0 ? ref5 : 1;
                var totalUSD1 = data === null || data === void 0 ? void 0 : (ref4 = data.pairDayDatas) === null || ref4 === void 0 ? void 0 : ref4.reduce(function(totalLiquidity, fetchPairEntry) {
                    return totalLiquidity + parseFloat(fetchPairEntry.reserveUSD);
                }, 0);
                return totalUSD1 / amountOfDataPoints1 > liquidityThreshold;
            }
        default:
            return null;
    }
};

;// CONCATENATED MODULE: ./src/state/swap/queries/pairDayDatas.ts

function pairDayDatas_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query pairDayDatas($pairId: String, $first: Int) {\n    pairDayDatas(first: $first, where: { pairAddress: $pairId }, orderBy: date, orderDirection: desc) {\n      id\n      date\n      reserve0\n      reserve1\n      reserveUSD\n      pairAddress {\n        token0 {\n          id\n        }\n        token1 {\n          id\n        }\n      }\n    }\n  }\n"
    ]);
    pairDayDatas_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var pairDayDatas = (0,graphql_request_dist.gql)(pairDayDatas_templateObject());
/* harmony default export */ var queries_pairDayDatas = (pairDayDatas);

;// CONCATENATED MODULE: ./src/state/swap/queries/pairHourDatasByIds.ts

function pairHourDatasByIds_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query pairHourDatasByIds($pairIds: [String]) {\n    pairHourDatas(where: { id_in: $pairIds }, orderBy: hourStartUnix, orderDirection: desc) {\n      id\n      hourStartUnix\n      reserve0\n      reserve1\n      reserveUSD\n      pair {\n        token0 {\n          id\n        }\n        token1 {\n          id\n        }\n      }\n    }\n  }\n"
    ]);
    pairHourDatasByIds_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var pairHourDatasByIds = (0,graphql_request_dist.gql)(pairHourDatasByIds_templateObject());
/* harmony default export */ var queries_pairHourDatasByIds = (pairHourDatasByIds);

;// CONCATENATED MODULE: ./src/state/swap/queries/lastPairHourId.ts

function lastPairHourId_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query lastPairHourId($pairId: String) {\n    pairHourDatas(first: 1, where: { pair: $pairId }, orderBy: hourStartUnix, orderDirection: desc) {\n      id\n    }\n  }\n"
    ]);
    lastPairHourId_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var lastPairHourId = (0,graphql_request_dist.gql)(lastPairHourId_templateObject());
/* harmony default export */ var queries_lastPairHourId = (lastPairHourId);

;// CONCATENATED MODULE: ./src/state/swap/fetch/fetchPairPriceData.ts













var fetchPairPriceData_fetchPairPriceData = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function(param) {
        var pairId, timeWindow, client, data, ref, lastPairHourIdData, lastId, pairHourId, pairHourIds, pairHoursData, data1, ref1, lastPairDayIdData, lastId1, pairLastId, pairDayIds, pairDayData, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    pairId = param.pairId, timeWindow = param.timeWindow;
                    client = infoClient;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        14,
                        ,
                        15
                    ]);
                    switch(timeWindow){
                        case types_PairDataTimeWindowEnum.DAY:
                            return [
                                3,
                                2
                            ];
                        case types_PairDataTimeWindowEnum.WEEK:
                            return [
                                3,
                                4
                            ];
                        case types_PairDataTimeWindowEnum.MONTH:
                            return [
                                3,
                                7
                            ];
                        case types_PairDataTimeWindowEnum.YEAR:
                            return [
                                3,
                                9
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        utils_requestWithTimeout(client, queries_pairHourDatas, {
                            pairId: pairId,
                            first: timeWindowIdsCountMapping[timeWindow]
                        })
                    ];
                case 3:
                    data = _state.sent();
                    return [
                        2,
                        {
                            data: data,
                            error: false
                        }
                    ];
                case 4:
                    return [
                        4,
                        utils_requestWithTimeout(client, queries_lastPairHourId, {
                            pairId: pairId
                        })
                    ];
                case 5:
                    lastPairHourIdData = _state.sent();
                    lastId = (lastPairHourIdData === null || lastPairHourIdData === void 0 ? void 0 : lastPairHourIdData.pairHourDatas) ? (ref = lastPairHourIdData.pairHourDatas[0]) === null || ref === void 0 ? void 0 : ref.id : null;
                    if (!lastId) {
                        return [
                            2,
                            {
                                data: {
                                    pairHourDatas: []
                                },
                                error: false
                            }
                        ];
                    }
                    pairHourId = getPairSequentialId({
                        id: lastId,
                        pairId: pairId
                    });
                    pairHourIds = getIdsByTimeWindow({
                        pairAddress: pairId,
                        pairLastId: pairHourId,
                        timeWindow: timeWindow,
                        idsCount: timeWindowIdsCountMapping[timeWindow]
                    });
                    return [
                        4,
                        utils_requestWithTimeout(client, queries_pairHourDatasByIds, {
                            pairIds: pairHourIds
                        })
                    ];
                case 6:
                    pairHoursData = _state.sent();
                    return [
                        2,
                        {
                            data: pairHoursData,
                            error: false
                        }
                    ];
                case 7:
                    return [
                        4,
                        utils_requestWithTimeout(client, queries_pairDayDatas, {
                            pairId: pairId,
                            first: timeWindowIdsCountMapping[timeWindow]
                        })
                    ];
                case 8:
                    data1 = _state.sent();
                    return [
                        2,
                        {
                            data: data1,
                            error: false
                        }
                    ];
                case 9:
                    return [
                        4,
                        utils_requestWithTimeout(client, queries_lastPairDayId, {
                            pairId: pairId
                        })
                    ];
                case 10:
                    lastPairDayIdData = _state.sent();
                    lastId1 = (lastPairDayIdData === null || lastPairDayIdData === void 0 ? void 0 : lastPairDayIdData.pairDayDatas) ? (ref1 = lastPairDayIdData.pairDayDatas[0]) === null || ref1 === void 0 ? void 0 : ref1.id : null;
                    if (!lastId1) {
                        return [
                            2,
                            {
                                data: {
                                    pairDayDatas: []
                                },
                                error: false
                            }
                        ];
                    }
                    pairLastId = getPairSequentialId({
                        id: lastId1,
                        pairId: pairId
                    });
                    pairDayIds = getIdsByTimeWindow({
                        pairAddress: pairId,
                        pairLastId: pairLastId,
                        timeWindow: timeWindow,
                        idsCount: timeWindowIdsCountMapping[timeWindow]
                    });
                    return [
                        4,
                        utils_requestWithTimeout(client, queries_pairDayDatasByIdsQuery, {
                            pairIds: pairDayIds
                        })
                    ];
                case 11:
                    pairDayData = _state.sent();
                    return [
                        2,
                        {
                            data: pairDayData,
                            error: false
                        }
                    ];
                case 12:
                    return [
                        2,
                        {
                            data: null,
                            error: false
                        }
                    ];
                case 13:
                    return [
                        3,
                        15
                    ];
                case 14:
                    error = _state.sent();
                    console.error("Failed to fetch price chart data", error);
                    return [
                        2,
                        {
                            error: true
                        }
                    ];
                case 15:
                    return [
                        2
                    ];
            }
        });
    });
    return function fetchPairPriceData(_) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var fetch_fetchPairPriceData = ((/* unused pure expression or super */ null && (fetchPairPriceData_fetchPairPriceData)));

;// CONCATENATED MODULE: ./src/state/swap/normalizers.ts



var normalizers_normalizeChartData = function(data, timeWindow) {
    switch(timeWindow){
        case PairDataTimeWindowEnum.DAY:
        case PairDataTimeWindowEnum.WEEK:
            var ref;
            return data === null || data === void 0 ? void 0 : (ref = data.pairHourDatas) === null || ref === void 0 ? void 0 : ref.map(function(fetchPairEntry) {
                return {
                    time: fetchPairEntry.hourStartUnix,
                    token0Id: fetchPairEntry.pair.token0.id,
                    token1Id: fetchPairEntry.pair.token1.id,
                    reserve0: parseFloat(fetchPairEntry.reserve0),
                    reserve1: parseFloat(fetchPairEntry.reserve1)
                };
            });
        case PairDataTimeWindowEnum.MONTH:
        case PairDataTimeWindowEnum.YEAR:
            var ref1;
            return data === null || data === void 0 ? void 0 : (ref1 = data.pairDayDatas) === null || ref1 === void 0 ? void 0 : ref1.map(function(fetchPairEntry) {
                return {
                    time: fetchPairEntry.date,
                    token0Id: fetchPairEntry.pairAddress.token0.id,
                    token1Id: fetchPairEntry.pairAddress.token1.id,
                    reserve0: parseFloat(fetchPairEntry.reserve0),
                    reserve1: parseFloat(fetchPairEntry.reserve1)
                };
            });
        default:
            return null;
    }
};
var normalizers_normalizeDerivedChartData = function(data) {
    if (!(data === null || data === void 0 ? void 0 : data.token0DerivedEos) || (data === null || data === void 0 ? void 0 : data.token0DerivedEos.length) === 0) {
        return [];
    }
    return data === null || data === void 0 ? void 0 : data.token0DerivedEos.reduce(function(acc, token0DerivedEosEntry) {
        var ref;
        var token1DerivedEosEntry = data === null || data === void 0 ? void 0 : (ref = data.token1DerivedEos) === null || ref === void 0 ? void 0 : ref.find(function(entry) {
            return entry.timestamp === token0DerivedEosEntry.timestamp;
        });
        if (!token1DerivedEosEntry) {
            return acc;
        }
        return _to_consumable_array(acc).concat([
            {
                time: parseInt(token0DerivedEosEntry.timestamp, 10),
                token0Id: token0DerivedEosEntry.tokenAddress,
                token1Id: token1DerivedEosEntry.tokenAddress,
                token0DerivedEOS: token0DerivedEosEntry.derivedEOS,
                token1DerivedEOS: token1DerivedEosEntry.derivedEOS
            }, 
        ]);
    }, []);
};
var normalizers_normalizePairDataByActiveToken = function(param) {
    var pairData = param.pairData, activeToken = param.activeToken;
    return pairData === null || pairData === void 0 ? void 0 : pairData.map(function(pairPrice) {
        return {
            time: fromUnixTime(pairPrice.time),
            value: activeToken === (pairPrice === null || pairPrice === void 0 ? void 0 : pairPrice.token0Id) ? pairPrice.reserve1 / pairPrice.reserve0 : pairPrice.reserve0 / pairPrice.reserve1
        };
    }).reverse();
};
var normalizers_normalizeDerivedPairDataByActiveToken = function(param) {
    var pairData = param.pairData, activeToken = param.activeToken;
    return pairData === null || pairData === void 0 ? void 0 : pairData.map(function(pairPrice) {
        return {
            time: fromUnixTime(pairPrice.time),
            value: activeToken === (pairPrice === null || pairPrice === void 0 ? void 0 : pairPrice.token0Id) ? pairPrice.token0DerivedEOS / pairPrice.token1DerivedEOS : pairPrice.token1DerivedEOS / pairPrice.token0DerivedEOS
        };
    });
};

// EXTERNAL MODULE: ./node_modules/lodash/get.js
var lodash_get = __webpack_require__(27361);
;// CONCATENATED MODULE: ./src/state/swap/selectors.ts

var selectors_pairByDataIdSelector = function(param) {
    var pairId = param.pairId, timeWindow = param.timeWindow;
    return function(state) {
        return get(state, [
            "swap",
            "pairDataById",
            pairId,
            timeWindow
        ]);
    };
};
var selectors_derivedPairByDataIdSelector = function(param) {
    var pairId = param.pairId, timeWindow = param.timeWindow;
    return function(state) {
        return get(state, [
            "swap",
            "derivedPairDataById",
            pairId,
            timeWindow
        ]);
    };
};

// EXTERNAL MODULE: ./node_modules/lodash/orderBy.js
var orderBy = __webpack_require__(75472);
var orderBy_default = /*#__PURE__*/__webpack_require__.n(orderBy);
// EXTERNAL MODULE: ./src/config/constants/info.ts
var info = __webpack_require__(4003);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
;// CONCATENATED MODULE: ./src/views/Info/utils/infoQueryHelpers.ts






/**
 * Helper function to get large amount GraphQL subqueries
 * @param queryConstructor constructor function that combines subqueries
 * @param subqueries individual queries
 * @param endpoint GraphQL endpoint
 * @param skipCount how many subqueries to fire at a time
 * @returns
 */ var multiQuery = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function(queryConstructor, subqueries, endpoint) {
        var skipCount, fetchedData, allFound, skip, client, end, subqueriesSlice, result, error;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    skipCount = _arguments.length > 3 && _arguments[3] !== void 0 ? _arguments[3] : 1000;
                    fetchedData = {};
                    allFound = false;
                    skip = 0;
                    client = new graphql_request_dist.GraphQLClient(endpoint, {
                        headers: getGQLHeaders(endpoint)
                    });
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    if (!!allFound) return [
                        3,
                        3
                    ];
                    end = subqueries.length;
                    if (skip + skipCount < subqueries.length) {
                        end = skip + skipCount;
                    }
                    subqueriesSlice = subqueries.slice(skip, end);
                    return [
                        4,
                        utils_requestWithTimeout(client, queryConstructor(subqueriesSlice))
                    ];
                case 2:
                    result = _state.sent();
                    fetchedData = (0,_object_spread/* default */.Z)({}, fetchedData, result);
                    allFound = Object.keys(result).length < skipCount || skip + skipCount > subqueries.length;
                    skip += skipCount;
                    return [
                        3,
                        1
                    ];
                case 3:
                    return [
                        2,
                        fetchedData
                    ];
                case 4:
                    error = _state.sent();
                    console.error("Failed to fetch info data", error);
                    return [
                        2,
                        null
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return function multiQuery(queryConstructor, subqueries, endpoint) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./src/utils/getBlocksFromTimestamps.ts



function getBlocksFromTimestamps_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "query blocks {\n    ",
        "\n  }"
    ]);
    getBlocksFromTimestamps_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var getBlockSubqueries = function(timestamps) {
    return timestamps.map(function(timestamp) {
        return "t".concat(timestamp, ":blocks(first: 1, orderBy: timestamp, orderDirection: desc, where: { timestamp_gt: ").concat(timestamp, ", timestamp_lt: ").concat(timestamp + 600, " }) {\n      number\n    }");
    });
};
var blocksQueryConstructor = function(subqueries) {
    return (0,graphql_request_dist.gql)(getBlocksFromTimestamps_templateObject(), subqueries);
};
/**
 * @notice Fetches block objects for an array of timestamps.
 * @param {Array} timestamps
 */ var getBlocksFromTimestamps = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function(timestamps) {
        var sortDirection, skipCount, fetchedData, blocks, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, key;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    sortDirection = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : "desc", skipCount = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : 500;
                    if ((timestamps === null || timestamps === void 0 ? void 0 : timestamps.length) === 0) {
                        return [
                            2,
                            []
                        ];
                    }
                    return [
                        4,
                        multiQuery(blocksQueryConstructor, getBlockSubqueries(timestamps), endpoints/* BLOCKS_CLIENT */.I0, skipCount)
                    ];
                case 1:
                    fetchedData = _state.sent();
                    blocks = [];
                    if (fetchedData) {
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            // eslint-disable-next-line no-restricted-syntax
                            for(_iterator = Object.keys(fetchedData)[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                key = _step.value;
                                if (fetchedData[key].length > 0) {
                                    blocks.push({
                                        timestamp: key.split("t")[1],
                                        number: parseInt(fetchedData[key][0].number, 10)
                                    });
                                }
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        // graphql-request does not guarantee same ordering of batched requests subqueries, hence manual sorting
                        return [
                            2,
                            orderBy_default()(blocks, function(block) {
                                return block.number;
                            }, sortDirection)
                        ];
                    }
                    return [
                        2,
                        blocks
                    ];
            }
        });
    });
    return function getBlocksFromTimestamps(timestamps) {
        return _ref.apply(this, arguments);
    };
}();

// EXTERNAL MODULE: ./node_modules/date-fns/esm/getUnixTime/index.js + 1 modules
var getUnixTime = __webpack_require__(28401);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/startOfHour/index.js
var startOfHour = __webpack_require__(12383);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/sub/index.js + 3 modules
var sub = __webpack_require__(55777);
;// CONCATENATED MODULE: ./src/state/swap/queries/getDerivedPrices.ts

function getDerivedPrices_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      query derivedTokenPriceData {\n        ",
        "\n      }\n    "
    ]);
    getDerivedPrices_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var getDerivedPrices = function(tokenAddress, blocks) {
    return blocks.map(function(block) {
        return "\n    t".concat(block.timestamp, ':token(id:"').concat(tokenAddress, '", block: { number: ').concat(block.number, " }) { \n        derivedEOS\n      }\n    ");
    });
};
var getDerivedPricesQueryConstructor = function(subqueries) {
    return (0,graphql_request_dist.gql)(getDerivedPrices_templateObject(), subqueries);
};

;// CONCATENATED MODULE: ./src/state/swap/fetch/fetchDerivedPriceData.ts











var getTokenDerivedEosPrices = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function(tokenAddress, blocks) {
        var prices, tokenPrices;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        multiQuery(getDerivedPricesQueryConstructor, getDerivedPrices(tokenAddress, blocks), endpoints/* INFO_CLIENT */.JY, 200)
                    ];
                case 1:
                    prices = _state.sent();
                    if (!prices) {
                        console.error("Price data failed to load");
                        return [
                            2,
                            null
                        ];
                    }
                    tokenPrices = [];
                    // Get Token prices in EOS
                    Object.keys(prices).forEach(function(priceKey) {
                        var timestamp = priceKey.split("t")[1];
                        if (timestamp) {
                            var ref;
                            tokenPrices.push({
                                tokenAddress: tokenAddress,
                                timestamp: timestamp,
                                derivedEOS: ((ref = prices[priceKey]) === null || ref === void 0 ? void 0 : ref.derivedEOS) ? parseFloat(prices[priceKey].derivedEOS) : 0
                            });
                        }
                    });
                    return [
                        2,
                        orderBy_default()(tokenPrices, function(tokenPrice) {
                            return parseInt(tokenPrice.timestamp, 10);
                        })
                    ];
            }
        });
    });
    return function getTokenDerivedEosPrices(tokenAddress, blocks) {
        return _ref.apply(this, arguments);
    };
}();
var getInterval = function(timeWindow) {
    switch(timeWindow){
        case types_PairDataTimeWindowEnum.DAY:
            return info/* ONE_HOUR_SECONDS */.Tb;
        case types_PairDataTimeWindowEnum.WEEK:
            return info/* ONE_HOUR_SECONDS */.Tb * 4;
        case types_PairDataTimeWindowEnum.MONTH:
            return info/* ONE_DAY_UNIX */.Bq;
        case types_PairDataTimeWindowEnum.YEAR:
            return info/* ONE_DAY_UNIX */.Bq * 15;
        default:
            return info/* ONE_HOUR_SECONDS */.Tb * 4;
    }
};
var getSkipDaysToStart = function(timeWindow) {
    switch(timeWindow){
        case types_PairDataTimeWindowEnum.DAY:
            return 1;
        case types_PairDataTimeWindowEnum.WEEK:
            return 7;
        case types_PairDataTimeWindowEnum.MONTH:
            return 30;
        case types_PairDataTimeWindowEnum.YEAR:
            return 365;
        default:
            return 7;
    }
};
// Fetches derivedEos values for tokens to calculate derived price
// Used when no direct pool is available
var fetchDerivedPriceData_fetchDerivedPriceData = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function(token0Address, token1Address, timeWindow) {
        var interval, endTimestamp, startTimestamp, timestamps, time, blocks, ref, token0DerivedEos, token1DerivedEos, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    interval = getInterval(timeWindow);
                    endTimestamp = (0,getUnixTime/* default */.Z)(new Date());
                    startTimestamp = (0,getUnixTime/* default */.Z)((0,startOfHour/* default */.Z)((0,sub/* default */.Z)(endTimestamp * 1000, {
                        days: getSkipDaysToStart(timeWindow)
                    })));
                    timestamps = [];
                    time = startTimestamp;
                    while(time <= endTimestamp){
                        timestamps.push(time);
                        time += interval;
                    }
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4,
                        getBlocksFromTimestamps(timestamps, "asc", 500)
                    ];
                case 2:
                    blocks = _state.sent();
                    if (!blocks || blocks.length === 0) {
                        console.error("Error fetching blocks for timestamps", timestamps);
                        return [
                            2,
                            null
                        ];
                    }
                    return [
                        4,
                        Promise.all([
                            getTokenDerivedEosPrices(token0Address, blocks),
                            getTokenDerivedEosPrices(token1Address, blocks)
                        ])
                    ];
                case 3:
                    ref = _sliced_to_array/* default.apply */.Z.apply(void 0, [
                        _state.sent(),
                        2
                    ]), token0DerivedEos = ref[0], token1DerivedEos = ref[1];
                    return [
                        2,
                        {
                            token0DerivedEos: token0DerivedEos,
                            token1DerivedEos: token1DerivedEos
                        }
                    ];
                case 4:
                    error = _state.sent();
                    console.error("Failed to fetched derived price data for chart", error);
                    return [
                        2,
                        null
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return function fetchDerivedPriceData(token0Address, token1Address, timeWindow) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var fetch_fetchDerivedPriceData = ((/* unused pure expression or super */ null && (fetchDerivedPriceData_fetchDerivedPriceData)));

;// CONCATENATED MODULE: ./src/state/swap/hooks.ts
/* eslint-disable */ 






























// import { parsePoolData, fetchPoolData, FormattedPoolFields } from '../info/queries/pools/poolData'
function useSwapState() {
    return (0,es/* useSelector */.v9)(function(state) {
        return state.swap;
    });
}
// TODO: update
var BAD_RECIPIENT_ADDRESSES = [
    "0x5C69bEe701ef814a2B6a3EDD4B1652CB9cc5aA6f",
    "0xf164fC0Ec4E93095b804a4795bBe1e041497b92a",
    "0x7a250d5630B4cF539739dF2C5dAcb4c659F2488D"
];
/**
 * Returns true if any of the pairs or tokens in a trade have the given checksummed address
 * @param trade to check for the given address
 * @param checksummedAddress address to check in the pairs and tokens
 */ function involvesAddress(trade, checksummedAddress) {
    return trade.route.path.some(function(token) {
        return token.address === checksummedAddress;
    }) || trade.route.pairs.some(function(pair) {
        return pair.liquidityToken.address === checksummedAddress;
    });
}
// Get swap price for single token disregarding slippage and price impact
function useSingleTokenSwapInfo(inputCurrencyId, inputCurrency, outputCurrencyId, outputCurrency) {
    var ref;
    var token0Address = getTokenAddress(inputCurrencyId);
    var token1Address = getTokenAddress(outputCurrencyId);
    var parsedAmount = tryParseAmount("1", inputCurrency !== null && inputCurrency !== void 0 ? inputCurrency : undefined);
    // console.log('执行了useSingleTokenSwapInfo方法')
    var bestTradeExactIn = useTradeExactIn(parsedAmount, outputCurrency !== null && outputCurrency !== void 0 ? outputCurrency : undefined);
    if (!inputCurrency || !outputCurrency || !bestTradeExactIn) {
        return null;
    }
    var inputTokenPrice = parseFloat(bestTradeExactIn === null || bestTradeExactIn === void 0 ? void 0 : (ref = bestTradeExactIn.executionPrice) === null || ref === void 0 ? void 0 : ref.toSignificant(6));
    var outputTokenPrice = 1 / inputTokenPrice;
    var _obj;
    return _obj = {}, _define_property(_obj, token0Address, inputTokenPrice), _define_property(_obj, token1Address, outputTokenPrice), _obj;
}
// from the current swap inputs, compute the best trade and return it.
function useDerivedSwapInfo(independentField, typedValue, inputCurrency, outputCurrency, recipient, listData) {
    var account = (0,src/* useWeb3React */.Ge)().account;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var ref;
    // console.log('传过来的🤡🤡🤡🤡🤡', listData)
    var to = (ref = recipient === null ? account : (0,utils/* isAddress */.UJ)(recipient) || null) !== null && ref !== void 0 ? ref : null;
    // 获取币种余额
    var relevantTokenBalances = (0,hooks/* useCurrencyBalances */.K5)(account !== null && account !== void 0 ? account : undefined, [
        inputCurrency !== null && inputCurrency !== void 0 ? inputCurrency : undefined,
        outputCurrency !== null && outputCurrency !== void 0 ? outputCurrency : undefined, 
    ]);
    var isExactIn = independentField === actions/* Field.INPUT */.gN.INPUT;
    var ref1;
    // 可以看看转换数量方法
    var parsedAmount = (0,utils_tryParseAmount/* default */.Z)(typedValue, (ref1 = isExactIn ? inputCurrency : outputCurrency) !== null && ref1 !== void 0 ? ref1 : undefined);
    // console.log(parsedAmount, 'parsedAmount')
    // console.log('执行了useDerivedSwapInfo方法')
    var bestTradeExactIn = (0,Trades/* useTradeExactIn */.AU)(isExactIn ? parsedAmount : undefined, outputCurrency !== null && outputCurrency !== void 0 ? outputCurrency : undefined, listData);
    // console.log('useDerivedSwapInfo', '触发了useTradeExactIn')
    var bestTradeExactOut = (0,Trades/* useTradeExactOut */["in"])(inputCurrency !== null && inputCurrency !== void 0 ? inputCurrency : undefined, !isExactIn ? parsedAmount : undefined, listData);
    // console.log('useDerivedSwapInfo', 'useTradeExactOut')
    var v2Trade = isExactIn ? bestTradeExactIn : bestTradeExactOut;
    var _obj;
    var currencyBalances = (_obj = {}, (0,src_define_property/* default */.Z)(_obj, actions/* Field.INPUT */.gN.INPUT, relevantTokenBalances[0]), (0,src_define_property/* default */.Z)(_obj, actions/* Field.OUTPUT */.gN.OUTPUT, relevantTokenBalances[1]), _obj);
    var _obj1;
    var currencies = (_obj1 = {}, (0,src_define_property/* default */.Z)(_obj1, actions/* Field.INPUT */.gN.INPUT, inputCurrency !== null && inputCurrency !== void 0 ? inputCurrency : undefined), (0,src_define_property/* default */.Z)(_obj1, actions/* Field.OUTPUT */.gN.OUTPUT, outputCurrency !== null && outputCurrency !== void 0 ? outputCurrency : undefined), _obj1);
    var inputError;
    if (!account) {
        inputError = t("noah1");
    }
    if (!parsedAmount) {
        inputError = inputError !== null && inputError !== void 0 ? inputError : t("noah144");
    }
    if (!currencies[actions/* Field.INPUT */.gN.INPUT] || !currencies[actions/* Field.OUTPUT */.gN.OUTPUT]) {
        inputError = inputError !== null && inputError !== void 0 ? inputError : t("noah142");
    }
    var formattedTo = (0,utils/* isAddress */.UJ)(to);
    if (!to || !formattedTo) {
        inputError = inputError !== null && inputError !== void 0 ? inputError : t("Enter a recipient");
    } else if (BAD_RECIPIENT_ADDRESSES.indexOf(formattedTo) !== -1 || bestTradeExactIn && involvesAddress(bestTradeExactIn, formattedTo) || bestTradeExactOut && involvesAddress(bestTradeExactOut, formattedTo)) {
        inputError = inputError !== null && inputError !== void 0 ? inputError : t("Invalid recipient");
    }
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,user_hooks/* useUserSlippageTolerance */.$2)(), 1), allowedSlippage = ref2[0];
    var slippageAdjustedAmounts = v2Trade && allowedSlippage && (0,utils_exchange/* computeSlippageAdjustedAmounts */.b5)(v2Trade, allowedSlippage);
    // compare input balance to max input based on version
    var ref3 = [
        currencyBalances[actions/* Field.INPUT */.gN.INPUT],
        slippageAdjustedAmounts ? slippageAdjustedAmounts[actions/* Field.INPUT */.gN.INPUT] : null, 
    ], balanceIn = ref3[0], amountIn = ref3[1];
    if (balanceIn && amountIn && balanceIn.lessThan(amountIn)) {
        inputError = t("Insufficient %symbol% balance", {
            symbol: amountIn.currency.symbol
        });
    }
    return {
        currencies: currencies,
        currencyBalances: currencyBalances,
        parsedAmount: parsedAmount,
        v2Trade: v2Trade !== null && v2Trade !== void 0 ? v2Trade : undefined,
        inputError: inputError,
        listData: listData
    };
}
function parseCurrencyFromURLParameter(urlParam) {
    if (typeof urlParam === "string") {
        var valid = (0,utils/* isAddress */.UJ)(urlParam);
        if (valid) return valid;
        if (urlParam.toUpperCase() === "EOS") return "EOS";
        if (valid === false) return "EOS";
    }
    return "";
}
function parseTokenAmountURLParameter(urlParam) {
    return typeof urlParam === "string" && !Number.isNaN(parseFloat(urlParam)) ? urlParam : "";
}
function parseIndependentFieldURLParameter(urlParam) {
    return typeof urlParam === "string" && urlParam.toLowerCase() === "output" ? actions/* Field.OUTPUT */.gN.OUTPUT : actions/* Field.INPUT */.gN.INPUT;
}
var ADDRESS_REGEX = /^0x[a-fA-F0-9]{40}$/;
function validatedRecipient(recipient) {
    if (typeof recipient !== "string") return null;
    var address = (0,utils/* isAddress */.UJ)(recipient);
    if (address) return address;
    if (ADDRESS_REGEX.test(recipient)) return recipient;
    return null;
}
function queryParametersToSwapState(parsedQs, nativeSymbol, defaultOutputCurrency) {
    var inputCurrency = parseCurrencyFromURLParameter(parsedQs.inputCurrency) || (nativeSymbol !== null && nativeSymbol !== void 0 ? nativeSymbol : exchange/* DEFAULT_INPUT_CURRENCY */.VN);
    var outputCurrency = parseCurrencyFromURLParameter(parsedQs.outputCurrency) || (defaultOutputCurrency !== null && defaultOutputCurrency !== void 0 ? defaultOutputCurrency : exchange/* DEFAULT_OUTPUT_CURRENCY */.g$);
    if (inputCurrency === outputCurrency) {
        if (typeof parsedQs.outputCurrency === "string") {
            inputCurrency = "";
        } else {
            outputCurrency = "";
        }
    }
    var recipient = validatedRecipient(parsedQs.recipient);
    var _obj;
    return _obj = {}, (0,src_define_property/* default */.Z)(_obj, actions/* Field.INPUT */.gN.INPUT, {
        currencyId: inputCurrency
    }), (0,src_define_property/* default */.Z)(_obj, actions/* Field.OUTPUT */.gN.OUTPUT, {
        currencyId: outputCurrency
    }), (0,src_define_property/* default */.Z)(_obj, "typedValue", parseTokenAmountURLParameter(parsedQs.exactAmount)), (0,src_define_property/* default */.Z)(_obj, "independentField", parseIndependentFieldURLParameter(parsedQs.exactField)), (0,src_define_property/* default */.Z)(_obj, "recipient", recipient), (0,src_define_property/* default */.Z)(_obj, "pairDataById", {}), (0,src_define_property/* default */.Z)(_obj, "derivedPairDataById", {}), _obj;
}
// updates the swap state to use the defaults for a given network
function useDefaultsFromURLSearch() {
    var chainId = (0,useActiveWeb3React/* default */.Z)().chainId;
    var dispatch = (0,state/* useAppDispatch */.TL)();
    var native = (0,useNativeCurrency/* default */.Z)();
    var query = (0,router.useRouter)().query;
    var ref = (0,react.useState)(), result = ref[0], setResult = ref[1];
    (0,react.useEffect)(function() {
        if (!chainId || !native) return;
        // const parsed = queryParametersToSwapState(query, native.symbol, NOAH[chainId]?.address ?? USDC[chainId]?.address)
        // swap 默认交易对 EOS --- NOAH
        var parsed = queryParametersToSwapState(query, native.symbol, "");
        dispatch((0,actions/* replaceSwapState */.mV)({
            typedValue: parsed.typedValue,
            field: parsed.independentField,
            inputCurrencyId: parsed[actions/* Field.INPUT */.gN.INPUT].currencyId,
            outputCurrencyId: parsed[actions/* Field.OUTPUT */.gN.OUTPUT].currencyId,
            recipient: null
        }));
        setResult({
            inputCurrencyId: parsed[actions/* Field.INPUT */.gN.INPUT].currencyId,
            outputCurrencyId: parsed[actions/* Field.OUTPUT */.gN.OUTPUT].currencyId
        });
    }, [
        dispatch,
        chainId,
        query,
        native
    ]);
    return result;
}
var useFetchPairPrices = function(param) {
    var token0Address = param.token0Address, token1Address = param.token1Address, timeWindow = param.timeWindow, currentSwapPrice = param.currentSwapPrice;
    var ref = useState(null), pairId = ref[0], setPairId = ref[1];
    var ref1 = useState(false), isLoading = ref1[0], setIsLoading = ref1[1];
    var pairData = useSelector(pairByDataIdSelector({
        pairId: pairId,
        timeWindow: timeWindow
    }));
    var derivedPairData = useSelector(derivedPairByDataIdSelector({
        pairId: pairId,
        timeWindow: timeWindow
    }));
    var dispatch = useDispatch();
    useEffect(function() {
        var fetchDerivedData = function() {
            var _ref = _async_to_generator(function() {
                var derivedData, normalizedDerivedData, error;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            console.info("[Price Chart]: Not possible to retrieve price data from single pool, trying to fetch derived prices");
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                4,
                                5
                            ]);
                            return [
                                4,
                                fetchDerivedPriceData(token0Address, token1Address, timeWindow)
                            ];
                        case 2:
                            derivedData = _state.sent();
                            if (derivedData) {
                                normalizedDerivedData = normalizeDerivedChartData(derivedData);
                                dispatch(updateDerivedPairData({
                                    pairData: normalizedDerivedData,
                                    pairId: pairId,
                                    timeWindow: timeWindow
                                }));
                            } else {
                                dispatch(updateDerivedPairData({
                                    pairData: [],
                                    pairId: pairId,
                                    timeWindow: timeWindow
                                }));
                            }
                            return [
                                3,
                                5
                            ];
                        case 3:
                            error = _state.sent();
                            console.error("Failed to fetch derived prices for chart", error);
                            dispatch(updateDerivedPairData({
                                pairData: [],
                                pairId: pairId,
                                timeWindow: timeWindow
                            }));
                            return [
                                3,
                                5
                            ];
                        case 4:
                            setIsLoading(false);
                            return [
                                7
                            ];
                        case 5:
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetchDerivedData() {
                return _ref.apply(this, arguments);
            };
        }();
        var fetchAndUpdatePairPrice = function() {
            var _ref = _async_to_generator(function() {
                var data, hasEnoughLiquidity, newPairData;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            setIsLoading(true);
                            return [
                                4,
                                fetchPairPriceData({
                                    pairId: pairId,
                                    timeWindow: timeWindow
                                })
                            ];
                        case 1:
                            data = _state.sent().data;
                            if (data) {
                                hasEnoughLiquidity = pairHasEnoughLiquidity(data, timeWindow);
                                newPairData = normalizeChartData(data, timeWindow) || [];
                                if (newPairData.length > 0 && hasEnoughLiquidity) {
                                    dispatch(updatePairData({
                                        pairData: newPairData,
                                        pairId: pairId,
                                        timeWindow: timeWindow
                                    }));
                                    setIsLoading(false);
                                } else {
                                    console.info("[Price Chart]: Liquidity too low for ".concat(pairId));
                                    dispatch(updatePairData({
                                        pairData: [],
                                        pairId: pairId,
                                        timeWindow: timeWindow
                                    }));
                                    fetchDerivedData();
                                }
                            } else {
                                dispatch(updatePairData({
                                    pairData: [],
                                    pairId: pairId,
                                    timeWindow: timeWindow
                                }));
                                fetchDerivedData();
                            }
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetchAndUpdatePairPrice() {
                return _ref.apply(this, arguments);
            };
        }();
        if (!pairData && !derivedPairData && pairId && !isLoading) {
            fetchAndUpdatePairPrice();
        }
    }, [
        pairId,
        timeWindow,
        pairData,
        currentSwapPrice,
        token0Address,
        token1Address,
        derivedPairData,
        dispatch,
        isLoading, 
    ]);
    useEffect(function() {
        var updatePairId = function() {
            try {
                var ref;
                var pairAddress = (ref = getLpAddress(token0Address, token1Address)) === null || ref === void 0 ? void 0 : ref.toLowerCase();
                if (pairAddress !== pairId) {
                    setPairId(pairAddress);
                }
            } catch (error) {
                setPairId(null);
            }
        };
        updatePairId();
    }, [
        token0Address,
        token1Address,
        pairId
    ]);
    var normalizedPairData = useMemo(function() {
        return normalizePairDataByActiveToken({
            activeToken: token0Address,
            pairData: pairData
        });
    }, [
        token0Address,
        pairData
    ]);
    var normalizedDerivedPairData = useMemo(function() {
        return normalizeDerivedPairDataByActiveToken({
            activeToken: token0Address,
            pairData: derivedPairData
        });
    }, [
        token0Address,
        derivedPairData
    ]);
    var hasSwapPrice = currentSwapPrice && currentSwapPrice[token0Address] > 0;
    var normalizedPairDataWithCurrentSwapPrice = (normalizedPairData === null || normalizedPairData === void 0 ? void 0 : normalizedPairData.length) > 0 && hasSwapPrice ? _to_consumable_array(normalizedPairData).concat([
        {
            time: new Date(),
            value: currentSwapPrice[token0Address]
        }
    ]) : normalizedPairData;
    var normalizedDerivedPairDataWithCurrentSwapPrice = (normalizedDerivedPairData === null || normalizedDerivedPairData === void 0 ? void 0 : normalizedDerivedPairData.length) > 0 && hasSwapPrice ? _to_consumable_array(normalizedDerivedPairData).concat([
        {
            time: new Date(),
            value: currentSwapPrice[token0Address]
        }
    ]) : normalizedDerivedPairData;
    var hasNoDirectData = normalizedPairDataWithCurrentSwapPrice && (normalizedPairDataWithCurrentSwapPrice === null || normalizedPairDataWithCurrentSwapPrice === void 0 ? void 0 : normalizedPairDataWithCurrentSwapPrice.length) === 0;
    var hasNoDerivedData = normalizedDerivedPairDataWithCurrentSwapPrice && (normalizedDerivedPairDataWithCurrentSwapPrice === null || normalizedDerivedPairDataWithCurrentSwapPrice === void 0 ? void 0 : normalizedDerivedPairDataWithCurrentSwapPrice.length) === 0;
    // undefined is used for loading
    var pairPrices = hasNoDirectData && hasNoDerivedData ? [] : undefined;
    if (normalizedPairDataWithCurrentSwapPrice && (normalizedPairDataWithCurrentSwapPrice === null || normalizedPairDataWithCurrentSwapPrice === void 0 ? void 0 : normalizedPairDataWithCurrentSwapPrice.length) > 0) {
        pairPrices = normalizedPairDataWithCurrentSwapPrice;
    } else if (normalizedDerivedPairDataWithCurrentSwapPrice && (normalizedDerivedPairDataWithCurrentSwapPrice === null || normalizedDerivedPairDataWithCurrentSwapPrice === void 0 ? void 0 : normalizedDerivedPairDataWithCurrentSwapPrice.length) > 0) {
        pairPrices = normalizedDerivedPairDataWithCurrentSwapPrice;
    }
    return {
        pairPrices: pairPrices,
        pairId: pairId
    };
};
var useLPApr = function(pair) {
    var ref = (0,dist/* default */.Z)(pair && pair.chainId === swap_sdk_src/* ChainId.EVM */.a_.EVM ? [
        "LP7dApr",
        pair.liquidityToken.address
    ] : null, /*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
        return (0,tslib_es6.__generator)(this, function(_state) {
            // const timestampsArray = getDeltaTimestamps()
            // const blocks = await getBlocksFromTimestamps(timestampsArray, 'desc', 1000)
            // const [block24h, block48h, block7d, block14d] = blocks ?? []
            // const { error, data } = await fetchPoolData(block24h.number, block48h.number, block7d.number, block14d.number, [
            //   pair.liquidityToken.address.toLowerCase(),
            // ])
            // if (error) return null
            // const formattedPoolData = parsePoolData(data?.now)
            // const formattedPoolData24h = parsePoolData(data?.oneDayAgo)
            // const formattedPoolData48h = parsePoolData(data?.twoDaysAgo)
            // const formattedPoolData7d = parsePoolData(data?.oneWeekAgo)
            // const formattedPoolData14d = parsePoolData(data?.twoWeeksAgo)
            // const current: FormattedPoolFields | undefined = formattedPoolData[pair.liquidityToken.address.toLowerCase()]
            // const oneDay: FormattedPoolFields | undefined = formattedPoolData24h[pair.liquidityToken.address.toLowerCase()]
            // const twoDays: FormattedPoolFields | undefined = formattedPoolData48h[pair.liquidityToken.address.toLowerCase()]
            // const week: FormattedPoolFields | undefined = formattedPoolData7d[pair.liquidityToken.address.toLowerCase()]
            // const twoWeeks: FormattedPoolFields | undefined = formattedPoolData14d[pair.liquidityToken.address.toLowerCase()]
            // const [volumeUSD] = getChangeForPeriod(current?.volumeUSD, oneDay?.volumeUSD, twoDays?.volumeUSD)
            // const [volumeUSDWeek] = getChangeForPeriod(current?.volumeUSD, week?.volumeUSD, twoWeeks?.volumeUSD)
            // const liquidityUSD = current ? current.reserveUSD : 0
            // const { lpApr7d } = getLpFeesAndApr(volumeUSD, volumeUSDWeek, liquidityUSD)
            // return lpApr7d ? { lpApr7d } : null
            return [
                2,
                null
            ];
        });
    }), {
        refreshInterval: constants/* SLOW_INTERVAL */.KI
    }), poolData = ref.data;
    return poolData;
};


/***/ }),

/***/ 28996:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ currencyId; }
/* harmony export */ });
function currencyId(currency) {
    var ref;
    if (currency === null || currency === void 0 ? void 0 : currency.isNative) return (ref = currency.symbol) === null || ref === void 0 ? void 0 : ref.toUpperCase();
    if (currency === null || currency === void 0 ? void 0 : currency.isToken) return currency.address;
    throw new Error("invalid currency");
}
/* harmony default export */ __webpack_exports__["Z"] = (currencyId);


/***/ }),

/***/ 32323:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

/* harmony import */ var _noahswap_sdk__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79331);
/* harmony import */ var utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93293);



var getLpAddress = function(token1, token2) {
    var chainId = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ChainId.EVM;
    var token1AsTokenInstance = token1;
    var token2AsTokenInstance = token2;
    if (!token1 || !token2) {
        return null;
    }
    if (typeof token1 === "string" || _instanceof(token1, String)) {
        var checksummedToken1Address = isAddress(token1);
        if (!checksummedToken1Address) {
            return null;
        }
        token1AsTokenInstance = new Token(chainId, checksummedToken1Address, 18, "LP");
    }
    if (typeof token2 === "string" || _instanceof(token2, String)) {
        var checksummedToken2Address = isAddress(token2);
        if (!checksummedToken2Address) {
            return null;
        }
        token2AsTokenInstance = new Token(chainId, checksummedToken2Address, 18, "LP");
    }
    return Pair.getAddress(token1AsTokenInstance, token2AsTokenInstance);
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (getLpAddress)));


/***/ }),

/***/ 97938:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _ethersproject_units__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61744);
/* harmony import */ var _noahswap_sdk__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79331);


// try to parse a user entered amount for a given token
function tryParseAmount(value, currency) {
    if (!value || !currency) {
        return undefined;
    }
    try {
        var typedValueParsed = (0,_ethersproject_units__WEBPACK_IMPORTED_MODULE_1__.parseUnits)(value, currency.decimals).toString();
        if (typedValueParsed !== "0") {
            return _noahswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .CurrencyAmount.fromRawAmount */ .ih.fromRawAmount(currency, _noahswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .JSBI.BigInt */ .QA.BigInt(typedValueParsed));
        }
    } catch (error) {
        // should fail if the user specifies too many decimal places of precision (or maybe exceed max uint?)
        console.debug('Failed to parse input amount: "'.concat(value, '"'), error);
    }
    // necessary for all paths to return a value
    return undefined;
}
/* harmony default export */ __webpack_exports__["Z"] = (tryParseAmount);


/***/ }),

/***/ 90570:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ uriToHttp; }
/* harmony export */ });
/* eslint-disable no-case-declarations */ /**
 * Given a URI that may be ipfs, ipns, http, or https protocol, return the fetch-able http(s) URLs for the same content
 * @param uri to convert to fetch-able http url
 */ function uriToHttp(uri) {
    var protocol = uri.split(":")[0].toLowerCase();
    switch(protocol){
        case "https":
            return [
                uri
            ];
        case "http":
            return [
                "https".concat(uri.substring(4)),
                uri
            ];
        case "ipfs":
            var ref;
            var hash = (ref = uri.match(/^ipfs:(\/\/)?(.*)$/i)) === null || ref === void 0 ? void 0 : ref[2];
            return [
                "https://cloudflare-ipfs.com/ipfs/".concat(hash, "/"),
                "https://ipfs.io/ipfs/".concat(hash, "/")
            ];
        case "ipns":
            var ref1;
            var name = (ref1 = uri.match(/^ipns:(\/\/)?(.*)$/i)) === null || ref1 === void 0 ? void 0 : ref1[2];
            return [
                "https://cloudflare-ipfs.com/ipns/".concat(name, "/"),
                "https://ipfs.io/ipns/".concat(name, "/")
            ];
        default:
            return [];
    }
}


/***/ }),

/***/ 53854:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bv": function() { return /* binding */ unwrappedToken; },
/* harmony export */   "pu": function() { return /* binding */ wrappedCurrency; }
/* harmony export */ });
/* unused harmony export wrappedCurrencyAmount */
/* harmony import */ var _noahswap_sdk__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79331);

function wrappedCurrency(currency, chainId) {
    return chainId && (currency === null || currency === void 0 ? void 0 : currency.isNative) ? _noahswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .WNATIVE */ .FX[chainId] : (currency === null || currency === void 0 ? void 0 : currency.isToken) ? currency : undefined;
}
function wrappedCurrencyAmount(currencyAmount, chainId) {
    var token = currencyAmount && chainId ? wrappedCurrency(currencyAmount.currency, chainId) : undefined;
    return token && currencyAmount ? CurrencyAmount.fromRawAmount(token, currencyAmount.quotient) : undefined;
}
function unwrappedToken(token) {
    if (token.equals(_noahswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .WNATIVE */ .FX[token.chainId])) return _noahswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Native.onChain */ ._r.onChain(token.chainId);
    return token;
}


/***/ })

}]);